(function () {
  'use strict';

  if (window.__FH_EVENTS_ADAPTER_INSTALLED__) return;
  window.__FH_EVENTS_ADAPTER_INSTALLED__ = true;
  window.__FH_EVENTS_PUBLIC_CONFIG_PROMISE__ = window.__FH_EVENTS_PUBLIC_CONFIG_PROMISE__ || null;
  window.__FH_EVENTS_STATE__ = window.__FH_EVENTS_STATE__ || {
    eventsBySlug: {},
    bookingBySlug: {},
    roots: [],
    openModalSlug: null,
    modal: null,
    modalOpener: null,
    paidHoldCountdownTimer: null,
    paidCartRemoveObserverInstalled: false,
    paidCheckoutPrecheckObserverInstalled: false,
    paidCheckoutLastSubmitter: null,
    paidCheckoutPrecheckBypassForm: null,
    paidCartReleaseEndpointBase: '',
    paidCartPreviousHolds: null,
    paidCartReleaseAttempts: {}
  };

  var EVENTS_STATE = window.__FH_EVENTS_STATE__;
  var PAID_SINGLE_SEAT_MESSAGE = 'Event tickets can only be booked one at a time.';
  var INTENDED_ACTION_PARAMETER = 'fh_event_action';

  function appProxyBindingError(reason) {
    var error = new Error(reason || 'app_proxy_request_binding_unavailable');
    error.fhReason = reason || 'app_proxy_request_binding_unavailable';
    return error;
  }

  function sha256HexExactBody(bodyText) {
    if (
      !window.crypto ||
      !window.crypto.subtle ||
      typeof window.crypto.subtle.digest !== 'function' ||
      typeof TextEncoder !== 'function'
    ) {
      return Promise.reject(appProxyBindingError('app_proxy_request_binding_unavailable'));
    }

    return window.crypto.subtle
      .digest('SHA-256', new TextEncoder().encode(bodyText))
      .then(function (digest) {
        return Array.prototype.map
          .call(new Uint8Array(digest), function (byte) {
            return byte.toString(16).padStart(2, '0');
          })
          .join('');
      });
  }

  function appProxyPostJson(url, body) {
    var parsed;
    var bodyText;

    try {
      parsed = new URL(url, window.location.origin);
      bodyText = JSON.stringify(body == null ? {} : body);
    } catch (error) {
      return Promise.reject(appProxyBindingError('app_proxy_request_binding_invalid'));
    }

    if (
      parsed.origin !== window.location.origin ||
      !parsed.pathname.startsWith('/apps/fh-bobbel/') ||
      typeof bodyText !== 'string' ||
      typeof window.fetch !== 'function'
    ) {
      return Promise.reject(appProxyBindingError('app_proxy_request_binding_invalid'));
    }

    parsed.searchParams.set('fh_method', 'POST');
    parsed.searchParams.set('fh_path', parsed.pathname);

    return sha256HexExactBody(bodyText).then(function (bodySha256) {
      parsed.searchParams.set('fh_body_sha256', bodySha256);
      return window.fetch(parsed.pathname + parsed.search, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: bodyText
      });
    });
  }

  window.FunnyHooksEventsAppProxyPostJson = appProxyPostJson;

  var DEFAULT_I18N = {
    loading: 'Veranstaltungen werden geladen…',
    empty: 'Derzeit sind keine neuen Termine eingetragen. Schau bald wieder vorbei.',
    load_error: 'Unsere Termine konnten gerade nicht geladen werden. Bitte versuche es später erneut.',
    maintenance: 'Maintenance, come a bit later, please.',
    login_required: 'Login erforderlich',
    login_cta: 'Einloggen zum Anmelden',
    registered: 'Angemeldet',
    checking: 'Anmeldestatus wird geprüft…',
    manage: 'Anmeldung verwalten',
    wait: 'Bitte warten…',
    cancelled: 'Anmeldung storniert',
    sold_out: 'Ausgebucht',
    not_registered: 'Noch nicht angemeldet',
    free_register: 'Kostenlos anmelden',
    register_check: 'Anmeldung prüfen',
    status_unavailable: 'Anmeldestatus konnte nicht geprüft werden.',
    modal_register_title: 'Kostenlos anmelden',
    modal_register_copy: 'Prüfe bitte Veranstaltung, Datum, Uhrzeit und Ort. Mit deiner Bestätigung reservieren wir deinen Platz verbindlich.',
    modal_register_primary: 'Anmeldung bestätigen',
    modal_cancel: 'Abbrechen',
    modal_close: 'Schließen',
    modal_manage_title: 'Anmeldung verwalten',
    modal_manage_copy: 'Deine Anmeldung ist bestätigt.',
    modal_cancel_copy: 'Wenn du bestätigst, wird deine Anmeldung storniert und dein Platz wieder freigegeben.',
    modal_cancel_primary: 'Anmeldung stornieren',
    modal_cancelling: 'Wird storniert…',
    modal_again_title: 'Erneut anmelden',
    modal_again_copy: 'Deine Anmeldung wurde storniert.',
    modal_again_primary: 'Erneut verbindlich anmelden',
    modal_registering: 'Wird angemeldet…',
    modal_full_copy: 'Für diesen Termin sind aktuell keine Plätze mehr verfügbar.',
    category_label: 'Kategorie',
    availability_label: 'Verfügbar',
    all_events: 'Alle Veranstaltungen ansehen',
    view_event: 'Veranstaltung ansehen',
    free_label: 'Kostenlos',
    places_available: 'Plätze verfügbar',
    few_places_available: 'Nur noch wenige Plätze',
    event_image_fallback: 'Bild zur Veranstaltung folgt',
    included_items: 'Im Preis enthalten',
    what_to_bring: 'Bitte mitbringen',
    audience: 'Für wen ist die Veranstaltung?',
    cancellation_policy: 'Stornierung',
    contact: 'Fragen zur Veranstaltung',
    booking_summary: 'Buchungsübersicht',
    date_time_label: 'Datum und Uhrzeit',
    location_label: 'Ort',
    quantity_label: 'Anzahl',
    one_place: '1 Platz',
    add_to_calendar: 'Zum Kalender hinzufügen',
    manage_registration: 'Anmeldung ansehen',
    login_required_copy: 'Melde dich an, um mit dieser Veranstaltung fortzufahren.',
    login_continue: 'Anmelden und fortfahren',
    external_more: 'Mehr erfahren',
    soon_bookable: 'Bald buchbar',
    paid_ticket_cta: 'Für {{price}} buchen',
    paid_entry_supporting: 'Ein Platz · Sicher bezahlen',
    paid_login_cta: 'Melde dich an, um mit dieser Veranstaltung fortzufahren.',
    paid_prepare_progress: 'Buchung wird vorbereitet…',
    paid_cart_progress: 'Ticket wird in den Warenkorb gelegt…',
    paid_cart_added: 'Ticket ist im Warenkorb.',
    paid_capacity_unavailable: 'Leider ist gerade kein Platz mehr frei.',
    paid_variant_unavailable: 'Die Buchung ist gerade nicht verfügbar.',
    paid_price_label: 'Preis',
    paid_price_payment_note: 'Platz erst nach Zahlung fix.',
    paid_price_missing: 'Preis derzeit nicht verfügbar.',
    paid_confirm_title: 'Buchung bestätigen',
    paid_confirm_copy: 'Prüfe bitte Veranstaltung, Datum, Uhrzeit, Ort und Preis. Nach deiner Bestätigung ist ein Platz 15 Minuten für dich reserviert. Deine Buchung ist erst nach erfolgreicher Zahlung bestätigt.',
    paid_confirm_primary: 'Weiter zur Kasse',
    paid_confirm_progress: 'Wir reservieren deinen Platz und bereiten den sicheren Checkout vor.',
    paid_confirm_price_error: 'Der Preis konnte gerade nicht bestätigt werden. Bitte versuche es später erneut.',
    paid_cart_error: 'Die Buchung konnte nicht in den Warenkorb gelegt werden.',
    paid_precheck_stale: 'Dein reservierter Platz ist nicht mehr gültig. Im Warenkorb kannst du das abgelaufene Ticket sicher entfernen.',
    paid_precheck_error: 'Wir können deine Reservierung gerade nicht bestätigen. Kehre zur Veranstaltung zurück und versuche es später erneut.',
    paid_link_fallback: 'Ticket ist im Warenkorb. Bitte öffne den Warenkorb, um zum Checkout zu gehen.',
    paid_try_again: 'Bitte nochmal versuchen.',
    paid_payment_note: 'Du bezahlst im Checkout. Dein Platz ist erst nach abgeschlossener Zahlung fix.',
    paid_status_paid_reserved: 'Dein bezahlter Platz ist bestätigt.',
    paid_status_reserved: 'Dein Platz ist reserviert.',
    paid_status_finalizing: 'Wir prüfen deine Zahlung und bestätigen deinen Platz gleich.',
    paid_status_finalizing_countdown: 'Wir halten deinen Platz noch {{time}} für den Checkout frei.',
    paid_status_expired: 'Deine Checkout-Reservierung ist abgelaufen. Du kannst die Buchung erneut starten.',
    paid_status_review_needed: 'Wir prüfen deine Buchung manuell und melden uns, falls wir etwas brauchen.',
    booking_unavailable: 'Die Anmeldung ist aktuell nicht verfügbar.',
    booking_progress: 'Wir melden dich an…',
    booking_success: 'Du bist verbindlich angemeldet.',
    booking_already: 'Du bist bereits angemeldet.',
    event_ended: 'Veranstaltung beendet',
    booking_full: 'Leider ausgebucht.',
    auth_retry: 'Bitte logge dich erneut ein und versuche es nochmal.',
    booking_error: 'Die Anmeldung konnte nicht abgeschlossen werden. Bitte versuche es erneut.',
    cancel_unavailable: 'Die Stornierung ist aktuell nicht verfügbar.',
    cancel_progress: 'Wir stornieren deine Anmeldung…',
    cancel_success: 'Deine Anmeldung wurde storniert.',
    cancel_not_reserved: 'Du bist aktuell nicht angemeldet.',
    cancel_error: 'Die Stornierung konnte nicht abgeschlossen werden. Bitte versuche es erneut.',
    categories: {
      workshop: 'Workshop',
      meetup: 'Treff',
      market: 'Markt',
      open_day: 'Tag der offenen Tür',
      course: 'Kurs',
      other: 'Event'
    }
  };

  function toBool(value) {
    return String(value) === 'true';
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function isFutureIso(value) {
    var time = Date.parse(String(value || ''));
    return Number.isFinite(time) && time > Date.now();
  }

  function secondsUntil(value) {
    var time = Date.parse(String(value || ''));
    if (!Number.isFinite(time)) return null;
    return Math.max(0, Math.ceil((time - Date.now()) / 1000));
  }

  function formatRemainingTime(seconds) {
    if (!Number.isFinite(seconds)) return '';
    var safeSeconds = Math.max(0, Math.ceil(seconds));
    var minutes = Math.floor(safeSeconds / 60);
    var rest = safeSeconds % 60;
    return String(minutes) + ':' + String(rest).padStart(2, '0');
  }

  function interpolate(template, values) {
    var out = safeText(template, '');
    Object.keys(values || {}).forEach(function (key) {
      out = out.split('{{' + key + '}}').join(String(values[key]));
    });
    return out;
  }

  function safeText(value, fallback) {
    if (value === null || value === undefined) return fallback || '';
    var txt = String(value).trim();
    return txt || (fallback || '');
  }

  function trackAnalytics(name, context, options) {
    var analytics = window.FunnyHooksEventsAnalytics;
    if (!analytics || typeof analytics.track !== 'function') return null;
    return analytics.track(name, context, options);
  }

  function analyticsSurface(cfg) {
    if (cfg && cfg.surface === 'drawer') return 'drawer';
    if (cfg && cfg.displayMode === 'detail') return 'detail';
    return 'catalogue';
  }

  function bookingAnalyticsContext(eventDto, cfg, viewModel, action) {
    return {
      event_slug: toSafeEventSlug(eventDto && eventDto.slug),
      surface: analyticsSurface(cfg),
      booking_mode: safeText(eventDto && eventDto.booking_mode, 'none'),
      customer_state: safeText(viewModel && viewModel.customerState, ''),
      action: safeText(action, '')
    };
  }

  function readI18n(root) {
    var i18n = Object.assign({}, DEFAULT_I18N, { categories: Object.assign({}, DEFAULT_I18N.categories) });
    var script = root && root.querySelector ? root.querySelector('[data-fh-events-i18n]') : null;
    if (!script) return i18n;

    try {
      var parsed = JSON.parse(script.textContent || '{}');
      if (!parsed || typeof parsed !== 'object') return i18n;
      Object.keys(parsed).forEach(function (key) {
        if (key === 'categories' && parsed.categories && typeof parsed.categories === 'object') {
          i18n.categories = Object.assign({}, i18n.categories, parsed.categories);
        } else if (typeof parsed[key] === 'string' && parsed[key]) {
          i18n[key] = parsed[key];
        }
      });
    } catch (e) {}

    return i18n;
  }

  function t(cfg, key) {
    var i18n = (cfg && cfg.i18n) || DEFAULT_I18N;
    return safeText(i18n[key], DEFAULT_I18N[key] || '');
  }

  function normalizeDisplayText(value) {
    var txt = safeText(value, '');
    if (!txt) return '';

    return txt
      .replace(/Nächste Terminie/g, 'Nächste Termine')
      .replace(/Stra�Ye/g, 'Straße')
      .replace(/Stra�e/g, 'Straße')
      .replace(/fÃ¼r/g, 'für')
      .replace(/verfÃ¼gbar/g, 'verfügbar');
  }

  function toFiniteNumber(value) {
    var n = typeof value === 'number' ? value : parseFloat(value);
    return Number.isFinite(n) ? n : null;
  }

  function getAvailabilitySummary(eventDto) {
    if (!eventDto) return null;

    var total = toFiniteNumber(eventDto.capacity_total);
    if (!Number.isFinite(total)) return null;

    var reserved = toFiniteNumber(eventDto.capacity_reserved);
    if (!Number.isFinite(reserved)) reserved = 0;

    reserved = Math.max(0, reserved);
    var available = Math.max(0, total - reserved);

    return {
      total: total,
      reserved: reserved,
      available: available
    };
  }

  function stripHtmlToText(html) {
    if (!html) return '';
    var tmp = document.createElement('div');
    tmp.innerHTML = String(html);
    return safeText(tmp.textContent || tmp.innerText || '');
  }

  function parseIsoDate(value) {
    if (!value) return null;
    var d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  function buildUrl(endpoint, limit) {
    var base = safeText(endpoint, '/apps/fh-bobbel/events');
    var glue = base.indexOf('?') === -1 ? '?' : '&';
    return base + glue + 'limit=' + encodeURIComponent(String(limit));
  }

  function buildConfigUrl(endpoint) {
    var base = safeText(endpoint, '/apps/fh-bobbel/events').replace(/\/+$/, '');
    if (!base) return '/apps/fh-bobbel/events/config';
    return base + '/config';
  }

  function fetchPublicConfig(endpoint) {
    if (window.__FH_EVENTS_PUBLIC_CONFIG_PROMISE__) return window.__FH_EVENTS_PUBLIC_CONFIG_PROMISE__;

    var url = buildConfigUrl(endpoint);
    window.__FH_EVENTS_PUBLIC_CONFIG_PROMISE__ = fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (payload) {
        var config = payload && payload.data && payload.data.config ? payload.data.config : null;
        if (!payload || payload.contract_version !== 'v1' || !config) {
          throw new Error('Unexpected v1 config envelope shape');
        }
        return {
          events_page_enabled: config.events_page_enabled !== false,
          events_drawer_enabled: config.events_drawer_enabled !== false,
          events_page_maintenance_message: safeText(
            config.events_page_maintenance_message,
            DEFAULT_I18N.maintenance
          ),
          updated_at: config.updated_at || null
        };
      });

    return window.__FH_EVENTS_PUBLIC_CONFIG_PROMISE__;
  }

  function resetPublicConfigCache() {
    window.__FH_EVENTS_PUBLIC_CONFIG_PROMISE__ = null;
  }

  function allowedExternalUrl(url) {
    if (!url) return null;
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.href;
    } catch (e) {}
    return null;
  }

  function allowedAllEventsUrl(url) {
    if (!url) return null;
    try {
      var parsed = new URL(url, window.location.origin);
      var isHttp = parsed.protocol === 'http:' || parsed.protocol === 'https:';
      if (!isHttp) return null;
      if (parsed.origin !== window.location.origin && /^\//.test(url)) return null;
      return parsed.href;
    } catch (e) {
      return null;
    }
  }

  function toSafeEventSlug(value) {
    var raw = safeText(value, '').toLowerCase();
    if (!raw) return null;
    return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(raw) ? raw : null;
  }

  function toSafeShopifyVariantId(value) {
    var raw = safeText(value, '');
    if (!raw) return null;
    return /^[0-9]+$/.test(raw) ? raw : null;
  }

  function toSafeCurrencyCode(value) {
    var raw = safeText(value, '').toUpperCase();
    return /^[A-Z]{3}$/.test(raw) ? raw : null;
  }

  function toSafeMinorUnitAmount(value) {
    var n = typeof value === 'number' ? value : parseInt(value, 10);
    if (!Number.isFinite(n) || Math.floor(n) !== n || n < 0) return null;
    return n;
  }

  function toSafeLinkageId(value) {
    var raw = safeText(value, '');
    if (!raw) return null;
    return /^[A-Za-z0-9._:-]{1,256}$/.test(raw) ? raw : null;
  }

  function buildDetailsHref(baseUrl, safeSlug) {
    if (!safeSlug) return null;
    var safeBase = allowedAllEventsUrl(baseUrl);
    if (!safeBase) return null;
    try {
      var parsed = new URL(safeBase, window.location.origin);
      parsed.searchParams.delete('event');
      parsed.searchParams.set('event', safeSlug);
      parsed.hash = 'event-' + safeSlug;
      return parsed.href;
    } catch (e) {
      return null;
    }
  }

  function buildFreeBookingUrl(eventDto, cfg) {
    var safeSlug = toSafeEventSlug(eventDto && eventDto.slug);
    if (!safeSlug) return null;

    var base = safeText((cfg && cfg.endpoint) || '/apps/fh-bobbel/events', '/apps/fh-bobbel/events').replace(/\/+$/, '');
    if (!base) return null;

    return base + '/' + encodeURIComponent(safeSlug) + '/free-bookings';
  }

  function buildFreeBookingCancelUrl(eventDto, cfg) {
    var safeSlug = toSafeEventSlug(eventDto && eventDto.slug);
    if (!safeSlug) return null;

    var base = safeText((cfg && cfg.endpoint) || '/apps/fh-bobbel/events', '/apps/fh-bobbel/events').replace(/\/+$/, '');
    if (!base) return null;

    return base + '/' + encodeURIComponent(safeSlug) + '/free-bookings/cancel';
  }

  function buildPaidPrepareUrl(eventDto, cfg) {
    var safeSlug = toSafeEventSlug(eventDto && eventDto.slug);
    if (!safeSlug) return null;

    var base = safeText((cfg && cfg.endpoint) || '/apps/fh-bobbel/events', '/apps/fh-bobbel/events').replace(/\/+$/, '');
    if (!base) return null;

    return base + '/' + encodeURIComponent(safeSlug) + '/paid-bookings/prepare';
  }

  function buildPaidCheckoutLinkUrl(eventDto, cfg, prepareId) {
    var safeSlug = toSafeEventSlug(eventDto && eventDto.slug);
    var safePrepareId = toSafeLinkageId(prepareId);
    if (!safeSlug || !safePrepareId) return null;

    var base = safeText((cfg && cfg.endpoint) || '/apps/fh-bobbel/events', '/apps/fh-bobbel/events').replace(/\/+$/, '');
    if (!base) return null;

    return base + '/' + encodeURIComponent(safeSlug) + '/paid-bookings/' + encodeURIComponent(safePrepareId) + '/checkout-link';
  }

  function buildPaidCheckoutPrecheckUrl(eventDto, cfg, prepareId) {
    var safeSlug = toSafeEventSlug(eventDto && eventDto.slug);
    var safePrepareId = toSafeLinkageId(prepareId);
    if (!safeSlug || !safePrepareId) return null;

    var base = safeText((cfg && cfg.endpoint) || '/apps/fh-bobbel/events', '/apps/fh-bobbel/events').replace(/\/+$/, '');
    if (!base) return null;

    return base + '/' + encodeURIComponent(safeSlug) + '/paid-bookings/' + encodeURIComponent(safePrepareId) + '/checkout-precheck';
  }

  function buildPaidCheckoutPrecheckUrlFromCartHold(cartHold, endpointBase) {
    var safeSlug = toSafeEventSlug(cartHold && cartHold.event_slug);
    var safePrepareId = toSafeLinkageId(cartHold && cartHold.prepare_id);
    if (!safeSlug || !safePrepareId) return null;

    var base = safeText(endpointBase || '/apps/fh-bobbel/events', '/apps/fh-bobbel/events').replace(/\/+$/, '');
    if (!base) return null;

    return base + '/' + encodeURIComponent(safeSlug) + '/paid-bookings/' + encodeURIComponent(safePrepareId) + '/checkout-precheck';
  }

  function buildPaidReleaseUrlFromCartHold(cartHold, endpointBase) {
    var safeSlug = toSafeEventSlug(cartHold && cartHold.event_slug);
    var safePrepareId = toSafeLinkageId(cartHold && cartHold.prepare_id);
    if (!safeSlug || !safePrepareId) return null;

    var base = safeText(endpointBase || '/apps/fh-bobbel/events', '/apps/fh-bobbel/events').replace(/\/+$/, '');
    if (!base) return null;

    return base + '/' + encodeURIComponent(safeSlug) + '/paid-bookings/' + encodeURIComponent(safePrepareId) + '/release';
  }

  function paidCartHoldKey(cartHold) {
    var safeSlug = toSafeEventSlug(cartHold && cartHold.event_slug);
    var safePrepareId = toSafeLinkageId(cartHold && cartHold.prepare_id);
    var safeHoldId = toSafeLinkageId(cartHold && cartHold.hold_id);
    if (!safeSlug || !safePrepareId || !safeHoldId) return null;
    return safeSlug + '|' + safePrepareId + '|' + safeHoldId;
  }

  function paidCartHoldProperties(cartHold) {
    var eventSlug = toSafeEventSlug(cartHold && cartHold.event_slug);
    var prepareId = toSafeLinkageId(cartHold && cartHold.prepare_id);
    var holdId = toSafeLinkageId(cartHold && cartHold.hold_id);
    var variantId = toSafeShopifyVariantId(cartHold && cartHold.variant_id);
    if (!eventSlug || !prepareId || !holdId || !variantId) return null;

    return {
      _fh_source: 'event_booking',
      _fh_event_slug: eventSlug,
      _fh_prepare_id: prepareId,
      _fh_hold_id: holdId,
      _fh_variant_id: variantId
    };
  }

  function normalizePaidCartLinePrice(item, cartCurrency) {
    var quantity = toFiniteNumber(item && item.quantity);
    var amountMinor = toSafeMinorUnitAmount(item && item.final_price);
    if (amountMinor === null) amountMinor = toSafeMinorUnitAmount(item && item.price);
    if (amountMinor === null && quantity === 1) {
      amountMinor = toSafeMinorUnitAmount(item && item.final_line_price);
    }
    if (amountMinor === null && quantity === 1) {
      amountMinor = toSafeMinorUnitAmount(item && item.line_price);
    }

    var currency = toSafeCurrencyCode((item && item.currency) || cartCurrency);
    if (amountMinor === null || amountMinor <= 0 || !currency) return null;
    return {
      amount_minor: amountMinor,
      currency: currency
    };
  }

  function normalizePaidCartHoldFromItem(item, cartCurrency) {
    var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : null;
    var quantity = toFiniteNumber(item && item.quantity);
    if (!properties || !Number.isFinite(quantity) || quantity <= 0) return null;
    if (safeText(properties._fh_source, '') !== 'event_booking') return null;

    var eventSlug = toSafeEventSlug(properties._fh_event_slug);
    var prepareId = toSafeLinkageId(properties._fh_prepare_id);
    var holdId = toSafeLinkageId(properties._fh_hold_id);
    var variantId = toSafeShopifyVariantId(properties._fh_variant_id) || toSafeShopifyVariantId(item && item.variant_id);
    if (!eventSlug || !prepareId || !holdId) return null;

    return {
      event_slug: eventSlug,
      prepare_id: prepareId,
      hold_id: holdId,
      variant_id: variantId,
      line_key: safeText(item && item.key, ''),
      quantity: quantity,
      cart_line_price: normalizePaidCartLinePrice(item, cartCurrency)
    };
  }

  function collectPaidCartHolds(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var cartCurrency = toSafeCurrencyCode(cart && cart.currency);
    var holds = [];
    items.forEach(function (item) {
      var hold = normalizePaidCartHoldFromItem(item, cartCurrency);
      if (hold) holds.push(hold);
    });
    return holds;
  }

  function paidCartEvidenceForHold(cartHold, holds) {
    var lines = Array.isArray(holds) ? holds : [];
    var matchingLines = lines.filter(function (candidate) {
      return candidate.event_slug === cartHold.event_slug
        && candidate.prepare_id === cartHold.prepare_id
        && candidate.hold_id === cartHold.hold_id;
    });
    return {
      matching_line_count: matchingLines.length,
      matching_total_quantity: matchingLines.reduce(function (total, candidate) {
        return total + (toFiniteNumber(candidate.quantity) || 0);
      }, 0),
      hold_id_occurrences: lines.filter(function (candidate) { return candidate.hold_id === cartHold.hold_id; }).length,
      prepare_id_occurrences: lines.filter(function (candidate) { return candidate.prepare_id === cartHold.prepare_id; }).length
    };
  }

  function findPaidCartSingleSeatViolation(holds) {
    var lines = Array.isArray(holds) ? holds : [];
    var holdCounts = {};
    var prepareCounts = {};
    lines.forEach(function (hold) {
      holdCounts[hold.hold_id] = (holdCounts[hold.hold_id] || 0) + 1;
      prepareCounts[hold.prepare_id] = (prepareCounts[hold.prepare_id] || 0) + 1;
    });

    for (var index = 0; index < lines.length; index += 1) {
      var line = lines[index];
      if (toFiniteNumber(line.quantity) !== 1) return { reason: 'invalid_quantity', cartHold: line };
      if (holdCounts[line.hold_id] > 1) return { reason: 'duplicate_hold', cartHold: line };
      if (prepareCounts[line.prepare_id] > 1) return { reason: 'duplicate_prepare', cartHold: line };
    }
    return null;
  }

  function renderPaidCartSingleSeatNotice(show) {
    var notices = document.querySelectorAll('[data-fh-event-cart-notice]');
    notices.forEach(function (notice) {
      notice.textContent = show ? PAID_SINGLE_SEAT_MESSAGE : '';
      notice.hidden = !show;
    });
  }

  function normalizePaidCartQuantities(holds, originalFetch) {
    var invalidLines = (Array.isArray(holds) ? holds : []).filter(function (hold) {
      return toFiniteNumber(hold.quantity) !== 1 && safeText(hold.line_key, '');
    });
    if (!invalidLines.length) return Promise.resolve(holds);

    return invalidLines.reduce(function (promise, hold) {
      return promise.then(function () {
        return originalFetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: hold.line_key, quantity: 1 })
        }).then(function (response) {
          if (!response || !response.ok) throw new Error('paid_cart_quantity_normalize_failed');
        });
      });
    }, Promise.resolve()).then(function () {
      return readCartForPaidRemoveObserver(originalFetch);
    });
  }

  function findRemovedPaidCartHolds(previousHolds, nextHolds) {
    if (!Array.isArray(previousHolds) || !Array.isArray(nextHolds)) return [];
    var nextByKey = {};
    nextHolds.forEach(function (hold) {
      var key = paidCartHoldKey(hold);
      if (key) nextByKey[key] = true;
    });

    return previousHolds.filter(function (hold) {
      var key = paidCartHoldKey(hold);
      return !!key && !nextByKey[key];
    });
  }

  function isShopifyCartMutationRequest(input, init) {
    var url = '';
    var method = 'GET';
    if (typeof input === 'string') {
      url = input;
    } else if (input && typeof input.url === 'string') {
      url = input.url;
      method = safeText(input.method, 'GET').toUpperCase();
    }
    if (init && init.method) method = safeText(init.method, method).toUpperCase();
    if (method !== 'POST') return false;

    try {
      var parsed = new URL(url, window.location.origin);
      return /\/cart\/(?:add|change|update|clear)(?:\.js)?$/.test(parsed.pathname);
    } catch (error) {
      return false;
    }
  }

  function isEventSurfaceAcceleratedCheckoutRequest(input, init) {
    if (!document.querySelector('[data-fh-events-surface="page"], [data-fh-events-surface="list"]')) return false;

    var url = '';
    var method = 'GET';
    if (typeof input === 'string') {
      url = input;
    } else if (input && typeof input.url === 'string') {
      url = input.url;
      method = safeText(input.method, 'GET').toUpperCase();
    }
    if (init && init.method) method = safeText(init.method, method).toUpperCase();
    if (method !== 'POST') return false;

    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin && parsed.pathname === '/shopify_pay/accelerated_checkout';
    } catch (error) {
      return false;
    }
  }

  function eventSurfaceAcceleratedCheckoutBlockedResponse() {
    return new Response('{}', {
      status: 200,
      headers: { 'Content-Type': 'application/json', 'X-FunnyHooks-Checkout-Eligibility': 'blocked' }
    });
  }

  function readCartForPaidRemoveObserver(originalFetch) {
    return originalFetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res || !res.ok) throw new Error('cart_read_failed');
        return res.json();
      })
      .then(collectPaidCartHolds);
  }

  function releasePreparedPaidBookingHold(cartHold, endpointBase) {
    var releaseUrl = buildPaidReleaseUrlFromCartHold(cartHold, endpointBase);
    if (!releaseUrl) return Promise.resolve(null);

    return postJson(releaseUrl, { hold_id: cartHold.hold_id }).catch(function () {
      return null;
    });
  }

  function clearRemovedPaidCartHoldLocalState(cartHold) {
    var slug = toSafeEventSlug(cartHold && cartHold.event_slug);
    if (!slug) return;

    var state = getState();
    var eventDto = state.eventsBySlug[slug];
    if (eventDto) {
      eventDto.customer_booking_status = '';
      eventDto.customer_booking_expires_at = '';
    }

    setBookingState(slug, {
      status: 'not_registered',
      expiresAt: '',
      hydrated: true,
      pending: false,
      infoMessage: '',
      errorMessage: '',
      lastAction: 'paid_cart_remove'
    });
    emitBookingStateChanged(slug, 'not_registered');
    renderAllEventRoots();
  }

  function releaseRemovedPaidCartHold(cartHold) {
    var state = getState();
    var key = paidCartHoldKey(cartHold);
    clearRemovedPaidCartHoldLocalState(cartHold);
    if (!key || state.paidCartReleaseAttempts[key]) return;
    state.paidCartReleaseAttempts[key] = true;

    releasePreparedPaidBookingHold(cartHold, state.paidCartReleaseEndpointBase).then(function (result) {
      document.dispatchEvent(new CustomEvent('fh:events:cart-line-released', {
        detail: { slug: toSafeEventSlug(cartHold && cartHold.event_slug), released: !!(result && result.ok) }
      }));
    });
  }

  function refreshPaidCartRemoveSnapshot(previousHolds, originalFetch) {
    readCartForPaidRemoveObserver(originalFetch)
      .then(function (nextHolds) {
        var violation = findPaidCartSingleSeatViolation(nextHolds);
        renderPaidCartSingleSeatNotice(!!violation);
        return normalizePaidCartQuantities(nextHolds, originalFetch).then(function (normalizedHolds) {
          findRemovedPaidCartHolds(previousHolds, normalizedHolds).forEach(releaseRemovedPaidCartHold);
          getState().paidCartPreviousHolds = normalizedHolds;
        });
      })
      .catch(function () {
        return null;
      });
  }

  function paidCartPreviousHoldsForMutation(originalFetch) {
    var state = getState();
    if (Array.isArray(state.paidCartPreviousHolds)) {
      return Promise.resolve(state.paidCartPreviousHolds.slice());
    }

    return readCartForPaidRemoveObserver(originalFetch)
      .then(function (holds) {
        getState().paidCartPreviousHolds = holds;
        return holds.slice();
      })
      .catch(function () {
        return null;
      });
  }

  function ensurePaidCartRemoveObserver(cfg) {
    var state = getState();
    state.paidCartReleaseEndpointBase = safeText((cfg && cfg.endpoint) || '/apps/fh-bobbel/events', '/apps/fh-bobbel/events').replace(/\/+$/, '');
    state.paidCartReleaseAttempts = state.paidCartReleaseAttempts || {};
    if (state.paidCartRemoveObserverInstalled || typeof window.fetch !== 'function') return;

    state.paidCartRemoveObserverInstalled = true;
    var originalFetch = window.fetch.bind(window);
    refreshPaidCartRemoveSnapshot(null, originalFetch);

    window.fetch = function (input, init) {
      if (isEventSurfaceAcceleratedCheckoutRequest(input, init)) {
        return Promise.resolve(eventSurfaceAcceleratedCheckoutBlockedResponse());
      }

      var shouldObserve = isShopifyCartMutationRequest(input, init);
      var previousHoldsPromise = shouldObserve ? paidCartPreviousHoldsForMutation(originalFetch) : Promise.resolve(null);

      return previousHoldsPromise.then(function (previousHolds) {
        return originalFetch(input, init).then(function (response) {
          if (shouldObserve && response && response.ok) {
            window.setTimeout(function () {
              refreshPaidCartRemoveSnapshot(previousHolds, originalFetch);
            }, 0);
          }
          return response;
        });
      });
    };
  }

  function cfgForPaidCartHold(cartHold) {
    var slug = toSafeEventSlug(cartHold && cartHold.event_slug);
    var state = getState();
    var found = null;
    if (!slug) return { endpoint: state.paidCartReleaseEndpointBase || '/apps/fh-bobbel/events', i18n: DEFAULT_I18N };

    state.roots.forEach(function (entry) {
      if (found || !entry || !entry.cfg || !Array.isArray(entry.slugs)) return;
      if (entry.slugs.indexOf(slug) !== -1) found = entry.cfg;
    });

    return found || { endpoint: state.paidCartReleaseEndpointBase || '/apps/fh-bobbel/events', i18n: DEFAULT_I18N };
  }

  function precheckPaidCartHoldForExplicitCheckout(cartHold, endpointBase, allHolds) {
    var precheckUrl = buildPaidCheckoutPrecheckUrlFromCartHold(cartHold, endpointBase);
    var properties = paidCartHoldProperties(cartHold);
    var cartLinePrice = cartHold && cartHold.cart_line_price ? cartHold.cart_line_price : null;
    if (!precheckUrl || !properties || !cartLinePrice) {
      var unavailableReason = !precheckUrl ? 'missing_precheck_url' : (!properties ? 'missing_cart_line_variant' : 'missing_cart_line_price');
      var unavailable = paidCheckoutPrecheckError('checkout_precheck_unavailable', unavailableReason);
      unavailable.cartHold = cartHold;
      throw unavailable;
    }

    return postJson(precheckUrl, {
      quantity: toFiniteNumber(cartHold && cartHold.quantity) || 1,
      cart_evidence: paidCartEvidenceForHold(cartHold, allHolds),
      properties_confirmed: properties,
      cart_line_price: cartLinePrice
    }).catch(function () {
      throw paidCheckoutPrecheckError('checkout_precheck_network_failed', 'network_or_server_error');
    }).then(function (precheckResult) {
      var precheckData = precheckResult && precheckResult.payload && precheckResult.payload.data ? precheckResult.payload.data : null;
      var precheckReason = safeText(precheckData && precheckData.reason, '');
      if (!precheckResult.ok || !precheckData || precheckData.can_checkout !== true) {
        var blocked = paidCheckoutPrecheckError('checkout_precheck_blocked', precheckReason || 'can_checkout_false');
        blocked.fhCustomerAction = safeText(precheckData && precheckData.customer_action, '');
        throw blocked;
      }
      return precheckData;
    }).catch(function (error) {
      error.cartHold = cartHold;
      throw error;
    });
  }

  function readPaidCartHoldsForExplicitCheckout() {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res || !res.ok) throw paidCheckoutPrecheckError('checkout_precheck_network_failed', 'cart_read_failed');
        return res.json();
      })
      .then(collectPaidCartHolds);
  }

  function precheckPaidCartForExplicitCheckout() {
    var state = getState();
    return readPaidCartHoldsForExplicitCheckout().then(function (holds) {
      if (!holds.length) return [];
      var violation = findPaidCartSingleSeatViolation(holds);
      if (violation) {
        renderPaidCartSingleSeatNotice(true);
        var blocked = paidCheckoutPrecheckError('checkout_precheck_blocked', violation.reason);
        blocked.cartHold = violation.cartHold;
        throw blocked;
      }
      return Promise.all(holds.map(function (hold) {
        return precheckPaidCartHoldForExplicitCheckout(hold, state.paidCartReleaseEndpointBase, holds);
      })).then(function () {
        return holds;
      });
    });
  }

  function renderExplicitCheckoutPrecheckFailure(error) {
    var cartHold = error && error.cartHold;
    var slug = toSafeEventSlug(cartHold && cartHold.event_slug);
    if (!slug) return;

    var reason = safeText(error && error.fhReason, 'checkout_precheck_blocked');
    var precheckReason = safeText(error && error.fhPrecheckReason, reason);
    var cfg = cfgForPaidCartHold(cartHold);
    var shouldRemoveLine = shouldClearPaidHoldForPrecheckReason(precheckReason);
    if (shouldRemoveLine) {
      clearPrecheckRejectedPaidCartHoldLocalState(cartHold);
      releasePrecheckRejectedPaidCartHold(cartHold);
    }
    setBookingState(slug, {
      status: 'paid_checkout_precheck_failed',
      expiresAt: '',
      hydrated: true,
      pending: false,
      infoMessage: '',
      errorMessage: getPaidCheckoutPrecheckMessage(cfg, reason === 'checkout_precheck_blocked' ? precheckReason : reason),
      lastAction: 'paid_checkout_precheck'
    });
    emitBookingStateChanged(slug, 'paid_checkout_precheck_failed');
    trackAnalytics('booking_error_shown', {
      event_slug: slug,
      surface: 'cart',
      booking_mode: 'shopify_checkout',
      customer_state: 'paid_checkout_precheck_failed',
      reason: reason === 'checkout_precheck_blocked' ? precheckReason : reason
    });
    document.dispatchEvent(new CustomEvent('fh:events:cart-recovery-required', {
      detail: { slug: slug, action: shouldRemoveLine ? 'remove_and_retry' : 'return_to_event' }
    }));
    renderAllEventRoots();
  }

  function shouldClearPaidHoldForPrecheckReason(reason) {
    var normalizedReason = safeText(reason, '');
    return [
      'unknown_hold',
      'hold_expired',
      'hold_released',
      'stale_cart_line',
      'missing_metadata',
      'missing_price_snapshot',
      'missing_cart_price',
      'missing_cart_line_price',
      'missing_cart_line_variant',
      'price_mismatch',
      'currency_mismatch'
    ].indexOf(normalizedReason) !== -1;
  }

  function clearPrecheckRejectedPaidCartHoldLocalState(cartHold) {
    var slug = toSafeEventSlug(cartHold && cartHold.event_slug);
    if (!slug) return;

    var state = getState();
    var eventDto = state.eventsBySlug[slug];
    if (eventDto) {
      eventDto.customer_booking_status = '';
      eventDto.customer_booking_expires_at = '';
    }
  }

  function releasePrecheckRejectedPaidCartHold(cartHold) {
    var state = getState();
    var key = paidCartHoldKey(cartHold);
    if (!key || state.paidCartReleaseAttempts[key]) return;
    state.paidCartReleaseAttempts[key] = true;
    releasePreparedPaidBookingHold(cartHold, state.paidCartReleaseEndpointBase);
  }

  function isExplicitCheckoutSubmit(event) {
    var state = getState();
    var form = event && event.target;
    if (!form || !form.tagName || String(form.tagName).toLowerCase() !== 'form') return false;
    if (state.paidCheckoutPrecheckBypassForm === form) {
      state.paidCheckoutPrecheckBypassForm = null;
      return false;
    }

    var submitter = event.submitter || state.paidCheckoutLastSubmitter;
    if (submitter && safeText(submitter.getAttribute && submitter.getAttribute('name'), '') !== 'checkout') return false;
    if (!submitter && !form.querySelector('[name="checkout"]')) return false;

    var knownHolds = state.paidCartPreviousHolds;
    if (Array.isArray(knownHolds) && knownHolds.length === 0) return false;
    return true;
  }

  function continueExplicitCheckout(form, submitter) {
    var state = getState();
    state.paidCheckoutPrecheckBypassForm = form;
    trackAnalytics('checkout_started', {
      surface: form && form.closest && form.closest('cart-drawer') ? 'cart_drawer' : 'cart',
      booking_mode: 'shopify_checkout',
      outcome: 'precheck_passed'
    });
    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitter || undefined);
      return;
    }

    if (form && typeof form.submit === 'function') {
      if (!submitter) {
        var hiddenCheckout = document.createElement('input');
        hiddenCheckout.type = 'hidden';
        hiddenCheckout.name = 'checkout';
        hiddenCheckout.value = '';
        form.appendChild(hiddenCheckout);
      }
      form.submit();
    }
  }

  function ensurePaidCheckoutPrecheckObserver(cfg) {
    var state = getState();
    state.paidCartReleaseEndpointBase = safeText((cfg && cfg.endpoint) || state.paidCartReleaseEndpointBase || '/apps/fh-bobbel/events', '/apps/fh-bobbel/events').replace(/\/+$/, '');
    if (state.paidCheckoutPrecheckObserverInstalled) return;
    state.paidCheckoutPrecheckObserverInstalled = true;

    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('[name="checkout"]') : null;
      if (target) getState().paidCheckoutLastSubmitter = target;
    }, true);

    document.addEventListener('submit', function (event) {
      if (!isExplicitCheckoutSubmit(event)) return;

      var form = event.target;
      var submitter = event.submitter || getState().paidCheckoutLastSubmitter || (form && form.querySelector ? form.querySelector('[name="checkout"]') : null);
      event.preventDefault();
      precheckPaidCartForExplicitCheckout()
        .then(function () {
          continueExplicitCheckout(form, submitter);
        })
        .catch(function (error) {
          getState().paidCheckoutPrecheckBypassForm = null;
          renderExplicitCheckoutPrecheckFailure(error);
        });
    }, true);
  }

  function bootstrapPaidCartRemoveObserver() {
    ensurePaidCartRemoveObserver({ endpoint: '/apps/fh-bobbel/events' });
    ensurePaidCheckoutPrecheckObserver({ endpoint: '/apps/fh-bobbel/events' });
  }

  function buildCustomerBookingsUrl(cfg, slugs) {
    if (!cfg || !Array.isArray(slugs) || !slugs.length) return null;
    var base = safeText((cfg && cfg.endpoint) || '/apps/fh-bobbel/events', '/apps/fh-bobbel/events').replace(/\/+$/, '');
    if (!base) return null;
    return base + '/my-bookings?slugs=' + encodeURIComponent(slugs.join(','));
  }

  function collectCustomerStatusEventSlugs(events) {
    if (!Array.isArray(events) || !events.length) return [];
    var seen = {};
    var out = [];
    events.forEach(function (eventDto) {
      var mode = safeText(eventDto && eventDto.booking_mode, 'none');
      if (mode !== 'free' && mode !== 'shopify_checkout') return;
      var slug = toSafeEventSlug(eventDto.slug);
      if (!slug || seen[slug]) return;
      seen[slug] = true;
      out.push(slug);
    });
    return out;
  }

  function safePublicPriceDisplay(value) {
    var txt = safeText(value, '');
    if (!txt || txt.length > 80 || /[\u0000-\u001F\u007F]/.test(txt)) return '';
    return txt;
  }

  function formatSafePriceAmount(eventDto, cfg) {
    var amountMinor = eventDto && eventDto.price_amount_minor;
    var currency = safeText(eventDto && eventDto.price_currency, '');
    if (!Number.isInteger(amountMinor) || amountMinor < 0 || !/^[A-Z]{3}$/.test(currency)) return '';

    try {
      return new Intl.NumberFormat((cfg && cfg.locale) || 'de-AT', {
        style: 'currency',
        currency: currency
      }).format(amountMinor / 100);
    } catch (e) {
      return '';
    }
  }

  function getPaidPriceSnapshot(eventDto, cfg) {
    var required = eventDto && safeText(eventDto.booking_mode, 'none') === 'shopify_checkout' && eventDto.price_required_for_paid_booking !== false;
    var display = safePublicPriceDisplay(eventDto && eventDto.price_display) || formatSafePriceAmount(eventDto, cfg);
    return {
      required: required,
      display: display,
      usable: !!display,
      missingRequired: !!required && !display
    };
  }

  function normalizeCustomerBookingStatus(value) {
    var status = safeText(value, '');
    if (status === 'reserved' || status === 'paid_reserved' || status === 'finalizing' || status === 'review_needed') return status;
    return '';
  }

  function normalizeCustomerBookingExpiresAt(value) {
    var expiresAt = safeText(value, '');
    return Number.isFinite(Date.parse(expiresAt)) ? expiresAt : '';
  }

  function safeCartContextText(value, maxLength) {
    var text = normalizeDisplayText(value)
      .replace(/[\u0000-\u001f\u007f]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return text.slice(0, maxLength || 160);
  }

  function safeCartContextIso(value) {
    var date = parseIsoDate(value);
    return date ? date.toISOString() : '';
  }

  function fetchCustomerBookingStatuses(events, cfg) {
    if (!cfg || !cfg.customerLoggedIn) return Promise.resolve({});
    var slugs = collectCustomerStatusEventSlugs(events);
    if (!slugs.length) return Promise.resolve({});

    var url = buildCustomerBookingsUrl(cfg, slugs);
    if (!url) return Promise.resolve({});

    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (payload) {
        var bookings = payload && payload.data && Array.isArray(payload.data.bookings) ? payload.data.bookings : [];
        var bySlug = {};
        bookings.forEach(function (booking) {
          var slug = toSafeEventSlug(booking && booking.event_slug);
          var status = normalizeCustomerBookingStatus(booking && booking.status);
          if (!slug || !status) return;
          bySlug[slug] = {
            status: status,
            expiresAt: normalizeCustomerBookingExpiresAt(booking && booking.expires_at)
          };
        });
        return bySlug;
      })
      .catch(function () {
        return {};
      });
  }

  function getState() {
    return EVENTS_STATE;
  }

  function getRootKey(root) {
    if (!root) return '';
    if (!root.__fhEventsRootKey) {
      root.__fhEventsRootKey = 'fh-events-root-' + String(Date.now()) + '-' + String(Math.random()).slice(2);
    }
    return root.__fhEventsRootKey;
  }

  function registerRoot(root, cfg) {
    var state = getState();
    var key = getRootKey(root);
    var found = null;
    state.roots.forEach(function (entry) {
      if (entry.key === key) found = entry;
    });
    if (found) {
      found.root = root;
      found.cfg = cfg;
      return found;
    }
    found = { key: key, root: root, cfg: cfg, slugs: [], events: [] };
    state.roots.push(found);
    return found;
  }

  function updateRootRegistration(root, cfg, events) {
    var entry = registerRoot(root, cfg);
    entry.cfg = cfg;
    entry.events = Array.isArray(events) ? events.slice() : [];
    entry.slugs = entry.events
      .map(function (eventDto) {
        return toSafeEventSlug(eventDto && eventDto.slug);
      })
      .filter(function (slug) {
        return !!slug;
      });
    return entry;
  }

  function getBookingState(slug) {
    if (!slug) return null;
    var state = getState();
    if (!state.bookingBySlug[slug]) {
      state.bookingBySlug[slug] = {
        slug: slug,
        status: 'unknown',
        pending: false,
        hydrated: false,
        errorMessage: '',
        infoMessage: '',
        lastAction: ''
      };
    }
    return state.bookingBySlug[slug];
  }

  function setBookingState(slug, patch) {
    if (!slug) return null;
    var current = getBookingState(slug);
    if (!patch) return current;
    Object.keys(patch).forEach(function (key) {
      current[key] = patch[key];
    });
    return current;
  }

  function upsertEvents(events) {
    var state = getState();
    if (!Array.isArray(events)) return;
    events.forEach(function (eventDto) {
      var slug = toSafeEventSlug(eventDto && eventDto.slug);
      if (!slug) return;
      state.eventsBySlug[slug] = eventDto;
    });
  }

  function patchEventCapacity(slug, eventUpdate) {
    if (!slug || !eventUpdate) return;
    var state = getState();
    var eventDto = state.eventsBySlug[slug];
    if (!eventDto) return;
    if (Number.isFinite(eventUpdate.capacity_reserved)) eventDto.capacity_reserved = eventUpdate.capacity_reserved;
    if (Number.isFinite(eventUpdate.capacity_total)) eventDto.capacity_total = eventUpdate.capacity_total;
  }

  function mergeBookingStatuses(events, cfg, statusBySlug, hadError) {
    if (!Array.isArray(events) || !cfg || !cfg.customerLoggedIn) return;
    events.forEach(function (eventDto) {
      var mode = safeText(eventDto && eventDto.booking_mode, 'none');
      if (!eventDto || (mode !== 'free' && mode !== 'shopify_checkout')) return;
      var slug = toSafeEventSlug(eventDto.slug);
      if (!slug) return;

      var statusEntry = statusBySlug ? statusBySlug[slug] : null;
      var status = normalizeCustomerBookingStatus(statusEntry && typeof statusEntry === 'object' ? statusEntry.status : statusEntry);
      var expiresAt = normalizeCustomerBookingExpiresAt(statusEntry && typeof statusEntry === 'object' ? statusEntry.expiresAt : '');
      if (status === 'finalizing' && expiresAt && !isFutureIso(expiresAt)) {
        status = '';
        expiresAt = '';
      }
      if (status) {
        eventDto.customer_booking_status = status;
        eventDto.customer_booking_expires_at = expiresAt;
        setBookingState(slug, {
          status: status,
          expiresAt: expiresAt,
          hydrated: true,
          pending: false,
          errorMessage: '',
          infoMessage: ''
        });
        return;
      }

      if (mode === 'shopify_checkout' && !hadError) {
        eventDto.customer_booking_status = '';
        eventDto.customer_booking_expires_at = '';
        var paidBooking = getBookingState(slug);
        if (paidBooking && !paidBooking.hydrated) {
          setBookingState(slug, {
            status: 'not_registered',
            expiresAt: '',
            hydrated: true,
            pending: false,
            errorMessage: '',
            infoMessage: ''
          });
        }
        return;
      }

      eventDto.customer_booking_status = '';
      eventDto.customer_booking_expires_at = '';
      setBookingState(slug, {
        status: hadError ? 'error' : 'not_registered',
        expiresAt: '',
        hydrated: !hadError,
        pending: false,
        errorMessage: hadError ? t(cfg, 'status_unavailable') : '',
        infoMessage: ''
      });
    });
  }

  function createBookingBadge(kind, message) {
    if (!message) return null;
    var badge = document.createElement('p');
    badge.className = 'fh-events__booking-badge';
    badge.setAttribute('data-status', safeText(kind, 'info'));
    badge.textContent = message;
    return badge;
  }

  function resetExpiredPaidHold(slug, booking, eventDto) {
    if (!booking || booking.status !== 'finalizing' || !booking.expiresAt || isFutureIso(booking.expiresAt)) return false;
    booking.status = 'not_registered';
    booking.expiresAt = '';
    booking.pending = false;
    booking.hydrated = true;
    booking.errorMessage = '';
    booking.infoMessage = t({ i18n: DEFAULT_I18N }, 'paid_status_expired');
    if (eventDto) {
      eventDto.customer_booking_status = '';
      eventDto.customer_booking_expires_at = '';
    }
    return true;
  }

  function buildEventViewModel(eventDto, cfg) {
    var slug = toSafeEventSlug(eventDto && eventDto.slug);
    var booking = slug ? getBookingState(slug) : null;
    var availability = getAvailabilitySummary(eventDto);
    var isFull = !!(availability && availability.available <= 0);
    var customerState = 'unknown';
    var badgeKind = 'info';
    var badgeText = '';
    var ctaKind = 'none';
    var ctaLabel = '';
    var ctaDisabled = false;
    var mode = safeText(eventDto && eventDto.booking_mode, 'none');
    var isEndedFreeEvent = mode === 'free' && (
      (Number.isFinite(Date.parse(eventDto.end_at)) && Date.parse(eventDto.end_at) <= Date.now())
      || (booking && booking.status === 'event_ended')
    );
    var paidHoldExpired = mode === 'shopify_checkout' && resetExpiredPaidHold(slug, booking, eventDto);
    var priceSnapshot = mode === 'shopify_checkout' ? getPaidPriceSnapshot(eventDto, cfg) : null;

    if (mode === 'shopify_checkout') {
      if (priceSnapshot && priceSnapshot.missingRequired) {
        customerState = 'price_missing';
        badgeKind = 'warning';
        badgeText = t(cfg, 'paid_price_missing');
        ctaKind = 'disabled';
        ctaLabel = t(cfg, 'paid_price_missing');
        ctaDisabled = true;
      } else if (!cfg.customerLoggedIn) {
        customerState = 'logged_out';
        badgeText = t(cfg, 'login_required_copy');
        ctaKind = 'login';
        ctaLabel = t(cfg, 'login_continue');
      } else if (booking && booking.pending) {
        customerState = booking.status || 'loading';
        badgeText = booking.infoMessage || t(cfg, 'paid_prepare_progress');
        ctaKind = 'disabled';
        ctaLabel = t(cfg, 'wait');
        ctaDisabled = true;
      } else if (booking && (booking.status === 'paid_reserved' || booking.status === 'reserved')) {
        customerState = booking.status;
        badgeKind = 'success';
        badgeText = booking.status === 'paid_reserved' ? t(cfg, 'paid_status_paid_reserved') : t(cfg, 'paid_status_reserved');
        ctaKind = 'disabled';
        ctaLabel = badgeText;
        ctaDisabled = true;
      } else if (booking && booking.status === 'finalizing') {
        customerState = 'finalizing';
        badgeKind = 'info';
        var remaining = secondsUntil(booking.expiresAt || (eventDto && eventDto.customer_booking_expires_at));
        badgeText = remaining !== null && remaining > 0
          ? interpolate(t(cfg, 'paid_status_finalizing_countdown'), { time: formatRemainingTime(remaining) })
          : t(cfg, 'paid_status_finalizing');
        ctaKind = 'disabled';
        ctaLabel = t(cfg, 'wait');
        ctaDisabled = true;
      } else if (booking && booking.status === 'review_needed') {
        customerState = 'review_needed';
        badgeKind = 'warning';
        badgeText = t(cfg, 'paid_status_review_needed');
        ctaKind = 'disabled';
        ctaLabel = t(cfg, 'wait');
        ctaDisabled = true;
      } else if (booking && booking.status === 'paid_checkout_precheck_failed') {
        customerState = 'paid_checkout_precheck_failed';
        badgeKind = 'warning';
        badgeText = booking.errorMessage || t(cfg, 'paid_precheck_stale');
        ctaKind = 'disabled';
        ctaLabel = t(cfg, 'paid_cart_added');
        ctaDisabled = true;
      } else if (booking && booking.status === 'error') {
        customerState = 'error';
        badgeKind = 'error';
        badgeText = t(cfg, 'status_unavailable');
        ctaKind = 'disabled';
        ctaLabel = t(cfg, 'register_check');
        ctaDisabled = true;
      } else if (!toSafeShopifyVariantId(eventDto && eventDto.shopify_variant_id)) {
        customerState = 'unavailable';
        badgeKind = 'warning';
        badgeText = t(cfg, 'paid_variant_unavailable');
        ctaKind = 'disabled';
        ctaLabel = t(cfg, 'paid_variant_unavailable');
        ctaDisabled = true;
      } else if (isFull) {
        customerState = 'full';
        badgeKind = 'warning';
        badgeText = t(cfg, 'paid_capacity_unavailable');
        ctaKind = 'disabled';
        ctaLabel = t(cfg, 'paid_capacity_unavailable');
        ctaDisabled = true;
      } else if (booking && booking.status === 'paid_cart_added') {
        customerState = 'paid_cart_added';
        badgeKind = 'success';
        badgeText = t(cfg, 'paid_cart_added');
        ctaKind = 'disabled';
        ctaLabel = t(cfg, 'paid_cart_added');
        ctaDisabled = true;
      } else if (booking && booking.status === 'paid_checkout_link_failed') {
        customerState = 'paid_checkout_link_failed';
        badgeKind = 'warning';
        badgeText = t(cfg, 'paid_link_fallback');
        ctaKind = 'disabled';
        ctaLabel = t(cfg, 'paid_cart_added');
        ctaDisabled = true;
      } else {
        customerState = 'paid_ready';
        badgeKind = 'info';
        badgeText = paidHoldExpired ? t(cfg, 'paid_status_expired') : t(cfg, 'paid_payment_note');
        ctaKind = 'paid_confirm';
        ctaLabel = interpolate(t(cfg, 'paid_ticket_cta'), {
          price: priceSnapshot && priceSnapshot.usable ? priceSnapshot.display : ''
        });
      }

      return {
        slug: slug,
        eventDto: eventDto,
        availability: availability,
        isEndedFreeEvent: false,
        customerState: customerState,
        badgeKind: badgeKind,
        badgeText: badgeText,
        ctaKind: ctaKind,
        ctaLabel: ctaLabel,
        ctaDisabled: ctaDisabled,
        priceDisplay: priceSnapshot && priceSnapshot.usable ? priceSnapshot.display : '',
        priceRequired: priceSnapshot ? priceSnapshot.required : false
      };
    }

    if (mode !== 'free') {
      return {
        slug: slug,
        eventDto: eventDto,
        availability: availability,
        isEndedFreeEvent: false,
        customerState: 'not_applicable',
        badgeKind: '',
        badgeText: '',
        ctaKind: '',
        ctaLabel: '',
        ctaDisabled: false
      };
    }

    if (cfg.customerLoggedIn && booking && booking.pending) {
      customerState = booking.status === 'reserved' ? 'reserved' : booking.status;
      badgeText = booking.status === 'reserved' ? t(cfg, 'registered') : t(cfg, 'checking');
      badgeKind = booking.status === 'reserved' ? 'success' : 'info';
      ctaKind = booking.status === 'reserved' ? 'manage' : 'disabled';
      ctaLabel = booking.status === 'reserved' ? t(cfg, 'manage') : t(cfg, 'wait');
      ctaDisabled = booking.status !== 'reserved';
    } else if (cfg.customerLoggedIn && booking && booking.status === 'reserved') {
      customerState = 'reserved';
      badgeKind = 'success';
      badgeText = t(cfg, 'registered');
      ctaKind = 'manage';
      ctaLabel = t(cfg, 'manage');
    } else if (isEndedFreeEvent) {
      customerState = 'event_ended';
      badgeKind = 'neutral';
      badgeText = t(cfg, 'event_ended');
      ctaKind = 'disabled';
      ctaLabel = t(cfg, 'event_ended');
      ctaDisabled = true;
    } else if (!cfg.customerLoggedIn) {
      customerState = 'logged_out';
      badgeText = t(cfg, 'login_required_copy');
      ctaKind = 'login';
      ctaLabel = t(cfg, 'login_continue');
    } else if (booking && booking.status === 'cancelled_local') {
      customerState = 'cancelled_local';
      badgeKind = 'info';
      badgeText = t(cfg, 'cancelled');
      if (isFull) {
        ctaKind = 'disabled';
        ctaLabel = t(cfg, 'sold_out');
        ctaDisabled = true;
      } else {
        ctaKind = 'modal';
        ctaLabel = t(cfg, 'modal_again_title');
      }
    } else if (isFull) {
      customerState = 'full';
      badgeKind = 'warning';
      badgeText = t(cfg, 'sold_out');
      ctaKind = 'disabled';
      ctaLabel = t(cfg, 'sold_out');
      ctaDisabled = true;
    } else if (booking && booking.status === 'not_registered') {
      customerState = 'not_registered';
      badgeKind = 'neutral';
      badgeText = t(cfg, 'not_registered');
      ctaKind = 'modal';
      ctaLabel = t(cfg, 'free_register');
    } else if (booking && (booking.status === 'loading' || !booking.hydrated)) {
      customerState = 'loading';
      badgeKind = 'info';
      badgeText = t(cfg, 'checking');
      ctaKind = 'disabled';
      ctaLabel = t(cfg, 'wait');
      ctaDisabled = true;
    } else {
      customerState = 'error';
      badgeKind = 'error';
      badgeText = t(cfg, 'status_unavailable');
      ctaKind = 'disabled';
      ctaLabel = t(cfg, 'register_check');
      ctaDisabled = true;
    }

    return {
      slug: slug,
      eventDto: eventDto,
      availability: availability,
      isEndedFreeEvent: isEndedFreeEvent,
      customerState: customerState,
      badgeKind: badgeKind,
      badgeText: badgeText,
      ctaKind: ctaKind,
      ctaLabel: ctaLabel,
      ctaDisabled: ctaDisabled
    };
  }

  function escapeIcsText(value) {
    return safeText(value, '')
      .replace(/\\/g, '\\\\')
      .replace(/\r?\n/g, '\\n')
      .replace(/,/g, '\\,')
      .replace(/;/g, '\\;');
  }

  function formatIcsDate(value) {
    var date = parseIsoDate(value);
    if (!date) return '';
    return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
  }

  function buildCalendarDownload(eventDto) {
    var slug = toSafeEventSlug(eventDto && eventDto.slug);
    var start = formatIcsDate(eventDto && eventDto.start_at);
    if (!slug || !start) return null;
    var end = formatIcsDate(eventDto && eventDto.end_at) || start;
    var lines = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//FunnyHooks//Events//EN',
      'BEGIN:VEVENT',
      'UID:' + slug + '@funnyhooks',
      'DTSTAMP:' + formatIcsDate(new Date().toISOString()),
      'DTSTART:' + start,
      'DTEND:' + end,
      'SUMMARY:' + escapeIcsText(eventDto && eventDto.title),
      'LOCATION:' + escapeIcsText(eventDto && eventDto.location_text),
      'END:VEVENT',
      'END:VCALENDAR'
    ];
    return {
      href: 'data:text/calendar;charset=utf-8,' + encodeURIComponent(lines.join('\r\n')),
      filename: 'funnyhooks-' + slug + '.ics'
    };
  }

  function getCancellationPolicy(eventDto) {
    var content = getStructuredEventContent(eventDto);
    var sections = content && Array.isArray(content.optionalSections) ? content.optionalSections : [];
    for (var index = 0; index < sections.length; index += 1) {
      if (sections[index] && sections[index].key === 'cancellation_policy') {
        return safeText(sections[index].text, '');
      }
    }
    return '';
  }

  function appendModalContextRow(list, label, value, selector) {
    if (!list || !value) return;
    var row = document.createElement('div');
    row.className = 'fh-events-modal__context-row';
    if (selector) row.setAttribute(selector, '');
    appendTextElement(row, 'dt', 'fh-events-modal__context-label', label);
    appendTextElement(row, 'dd', 'fh-events-modal__context-value', value);
    list.appendChild(row);
  }

  function ensureModal() {
    var state = getState();
    if (state.modal && state.modal.parentNode) return state.modal;
    var modal = document.createElement('div');
    modal.className = 'fh-events-modal';
    modal.setAttribute('data-fh-events-modal', '');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="fh-events-modal__backdrop" data-fh-events-modal-close></div>' +
      '<div class="fh-events-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="fh-events-modal-title">' +
      '<button type="button" class="fh-events-modal__close" data-fh-events-modal-close aria-label="' + DEFAULT_I18N.modal_close + '">×</button>' +
      '<div class="fh-events-modal__content" data-fh-events-modal-content></div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (event) {
      if (event.target && event.target.hasAttribute('data-fh-events-modal-close')) closeBookingModal();
    });
    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeBookingModal();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = modal.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    state.modal = modal;
    return modal;
  }

  function closeBookingModal() {
    var state = getState();
    var modal = ensureModal();
    modal.hidden = true;
    var closingBooking = state.openModalSlug ? getBookingState(state.openModalSlug) : null;
    if (closingBooking && closingBooking.lastAction === 'reserve') {
      closingBooking.successAcknowledged = true;
    }
    state.openModalSlug = null;
    if (state.modalOpener && state.modalOpener.focus) {
      try {
        state.modalOpener.focus();
      } catch (e) {}
    }
    state.modalOpener = null;
  }

  function renderBookingModal(cfg) {
    var state = getState();
    var modal = ensureModal();
    var content = modal.querySelector('[data-fh-events-modal-content]');
    if (!content) return;
    var slug = state.openModalSlug;
    var eventDto = slug ? state.eventsBySlug[slug] : null;
    if (!slug || !eventDto) {
      closeBookingModal();
      return;
    }
    var viewModel = buildEventViewModel(eventDto, cfg);
    var booking = getBookingState(slug) || {};
    var mode = safeText(eventDto && eventDto.booking_mode, 'none');
    var title = t(cfg, 'modal_register_title');
    var copy = t(cfg, 'modal_register_copy');
    var primaryLabel = t(cfg, 'modal_register_primary');
    var primaryAction = 'reserve';
    var secondaryLabel = t(cfg, 'modal_cancel');
    var disablePrimary = !!booking.pending;
    var priceValue = mode === 'free' ? t(cfg, 'free_label') : '';
    var isFreeSuccess = false;

    if (mode === 'shopify_checkout') {
      title = t(cfg, 'paid_confirm_title');
      copy = booking.pending ? t(cfg, 'paid_confirm_progress') : t(cfg, 'paid_confirm_copy');
      primaryLabel = booking.pending ? t(cfg, 'wait') : t(cfg, 'paid_confirm_primary');
      primaryAction = 'paid_confirm';
      secondaryLabel = t(cfg, 'modal_cancel');
      priceValue = viewModel.priceDisplay || t(cfg, 'paid_confirm_price_error');
      disablePrimary = !!booking.pending || !viewModel.priceDisplay || viewModel.customerState !== 'paid_ready';
    } else if (viewModel.customerState === 'reserved') {
      title = t(cfg, 'modal_manage_title');
      isFreeSuccess = booking.lastAction === 'reserve' && !booking.successAcknowledged;
      copy = isFreeSuccess ? t(cfg, 'modal_manage_copy') : t(cfg, 'modal_cancel_copy');
      primaryLabel = booking.pending ? t(cfg, 'modal_cancelling') : t(cfg, 'modal_cancel_primary');
      primaryAction = 'cancel';
      secondaryLabel = t(cfg, 'modal_close');
    } else if (viewModel.customerState === 'cancelled_local') {
      title = t(cfg, 'modal_again_title');
      copy = t(cfg, 'modal_again_copy');
      primaryLabel = booking.pending ? t(cfg, 'modal_registering') : t(cfg, 'modal_again_primary');
      primaryAction = 'reserve';
      secondaryLabel = t(cfg, 'modal_close');
    } else if (viewModel.customerState === 'event_ended') {
      title = t(cfg, 'event_ended');
      copy = t(cfg, 'event_ended');
      primaryLabel = t(cfg, 'event_ended');
      primaryAction = 'none';
      secondaryLabel = t(cfg, 'modal_close');
      disablePrimary = true;
    } else if (viewModel.customerState === 'full') {
      title = t(cfg, 'sold_out');
      copy = t(cfg, 'modal_full_copy');
      primaryLabel = t(cfg, 'sold_out');
      primaryAction = 'none';
      secondaryLabel = t(cfg, 'modal_close');
      disablePrimary = true;
    } else if (booking.pending) {
      primaryLabel = t(cfg, 'wait');
      disablePrimary = true;
    }

    var infoAlreadyShownInCopy = isFreeSuccess || (
      viewModel.customerState === 'cancelled_local' && booking.lastAction === 'cancel'
    );
    var statusMessage = normalizeDisplayText(booking.errorMessage || (infoAlreadyShownInCopy ? '' : booking.infoMessage) || '');
    var statusKind = booking.errorMessage ? 'error' : booking.infoMessage ? 'success' : '';
    if (booking.errorMessage) {
      trackAnalytics('booking_error_shown', {
        event_slug: slug,
        surface: 'booking_modal',
        booking_mode: mode,
        customer_state: viewModel.customerState,
        outcome: 'error'
      }, { once: true, dedupeKey: slug + ':' + viewModel.customerState + ':' + booking.errorMessage });
    }
    if (isFreeSuccess) {
      trackAnalytics('booking_confirmation_viewed', {
        event_slug: slug,
        surface: 'booking_modal',
        booking_mode: 'free',
        customer_state: 'reserved'
      }, { once: true, dedupeKey: 'free:' + slug });
    }
    content.replaceChildren();
    content.setAttribute('aria-busy', booking.pending ? 'true' : 'false');
    var closeButton = modal.querySelector('.fh-events-modal__close');
    if (closeButton) closeButton.setAttribute('aria-label', t(cfg, 'modal_close'));
    var dialog = modal.querySelector('.fh-events-modal__dialog');
    if (dialog) dialog.setAttribute('aria-describedby', 'fh-events-modal-description');

    appendTextElement(
      content,
      'h2',
      'fh-events-modal__title',
      normalizeDisplayText(safeText(eventDto.title, 'Event'))
    ).id = 'fh-events-modal-title';
    appendTextElement(content, 'p', 'fh-events-modal__eyebrow', title);
    var copyElement = appendTextElement(content, 'p', 'fh-events-modal__copy', copy);
    if (copyElement) copyElement.id = 'fh-events-modal-description';

    var context = document.createElement('dl');
    context.className = 'fh-events-modal__context';
    context.setAttribute('data-fh-events-modal-context', '');
    appendModalContextRow(
      context,
      t(cfg, 'date_time_label'),
      normalizeDisplayText(formatDateRange(eventDto, cfg.locale, cfg.fallbackTz) || ''),
      'data-fh-events-modal-date-time'
    );
    appendModalContextRow(
      context,
      t(cfg, 'location_label'),
      normalizeDisplayText(eventDto.location_text),
      'data-fh-events-modal-location'
    );
    appendModalContextRow(
      context,
      t(cfg, 'paid_price_label'),
      priceValue,
      'data-fh-events-modal-price'
    );
    if (mode === 'shopify_checkout') {
      appendModalContextRow(
        context,
        t(cfg, 'quantity_label'),
        t(cfg, 'one_place'),
        'data-fh-events-modal-quantity'
      );
    }
    content.appendChild(context);

    if (viewModel.customerState === 'reserved') {
      var cancellationPolicy = getCancellationPolicy(eventDto);
      if (cancellationPolicy) {
        var policy = document.createElement('section');
        policy.className = 'fh-events-modal__policy';
        policy.setAttribute('data-fh-events-modal-cancellation-policy', '');
        appendTextElement(policy, 'h3', 'fh-events-modal__policy-title', t(cfg, 'cancellation_policy'));
        appendTextElement(policy, 'p', 'fh-events-modal__policy-copy', cancellationPolicy);
        content.appendChild(policy);
      }
    }

    if (isFreeSuccess) {
      var successLinks = document.createElement('div');
      successLinks.className = 'fh-events-modal__success-links';
      successLinks.setAttribute('data-fh-events-modal-success-actions', '');
      var calendar = buildCalendarDownload(eventDto);
      if (calendar) {
        var calendarLink = document.createElement('a');
        calendarLink.className = 'fh-events-modal__link';
        calendarLink.href = calendar.href;
        calendarLink.download = calendar.filename;
        calendarLink.textContent = t(cfg, 'add_to_calendar');
        calendarLink.setAttribute('data-fh-events-add-to-calendar', '');
        successLinks.appendChild(calendarLink);
      }
      var manageHref = buildDetailsHref(cfg.allEventsUrl || window.location.pathname, slug);
      if (manageHref) {
        var manageLink = document.createElement('a');
        manageLink.className = 'fh-events-modal__link';
        manageLink.href = manageHref;
        manageLink.textContent = t(cfg, 'manage_registration');
        manageLink.setAttribute('data-fh-events-manage-registration', '');
        successLinks.appendChild(manageLink);
      }
      if (successLinks.childElementCount) content.appendChild(successLinks);
    }

    var actions = document.createElement('div');
    actions.className = 'fh-events-modal__actions';
    if (primaryAction !== 'none') {
      var primaryButton = document.createElement('button');
      primaryButton.type = 'button';
      primaryButton.className = 'fh-events-modal__button fh-events-modal__button--primary';
      primaryButton.textContent = primaryLabel;
      primaryButton.disabled = disablePrimary;
      primaryButton.setAttribute('data-fh-events-modal-action', primaryAction);
      if (booking.pending) primaryButton.setAttribute('aria-disabled', 'true');
      actions.appendChild(primaryButton);
    }
    var secondaryButton = document.createElement('button');
    secondaryButton.type = 'button';
    secondaryButton.className = 'fh-events-modal__button fh-events-modal__button--secondary';
    secondaryButton.textContent = secondaryLabel;
    secondaryButton.setAttribute('data-fh-events-modal-close', '');
    actions.appendChild(secondaryButton);
    content.appendChild(actions);

    var status = appendTextElement(content, 'p', 'fh-events-modal__status', statusMessage || ' ');
    if (status) {
      status.setAttribute('data-status', safeText(statusKind, 'info'));
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
    }

    var actionBtn = content.querySelector('[data-fh-events-modal-action]');
    if (actionBtn) {
      actionBtn.addEventListener('click', function () {
        if (actionBtn.disabled) return;
        actionBtn.disabled = true;
        actionBtn.setAttribute('aria-disabled', 'true');
        content.setAttribute('aria-busy', 'true');
        if (primaryAction === 'reserve') {
          submitFreeBookingBySlug(slug, cfg);
        } else if (primaryAction === 'cancel') {
          cancelFreeBookingBySlug(slug, cfg);
        } else if (primaryAction === 'paid_confirm') {
          submitPaidBookingBySlug(slug, cfg);
        }
      });
    }
  }

  function openBookingModal(slug, cfg, opener) {
    if (!slug) return;
    var state = getState();
    state.openModalSlug = slug;
    state.modalOpener = opener || null;
    var modal = ensureModal();
    modal.hidden = false;
    var eventDto = state.eventsBySlug[slug];
    var viewModel = eventDto ? buildEventViewModel(eventDto, cfg) : null;
    trackAnalytics('booking_modal_opened', bookingAnalyticsContext(eventDto, cfg, viewModel, 'open_modal'));
    renderBookingModal(cfg);
    var initialFocus = modal.querySelector('button[data-fh-events-modal-close]');
    if (initialFocus && initialFocus.focus) initialFocus.focus();
  }

  function refreshAllEventRoots() {
    var state = getState();
    resetPublicConfigCache();
    state.roots.forEach(function (entry) {
      if (!entry || !entry.root) return;
      entry.root.__fhEventsInitialized = false;
    });
    init();
  }

  function renderRootFromEntry(entry) {
    if (!entry || !entry.root || !entry.cfg) return;
    renderEvents(entry.root, entry.events, entry.cfg);
  }

  function emitBookingStateChanged(slug, status) {
    document.dispatchEvent(
      new CustomEvent('fh:events:booking-state-changed', {
        detail: { slug: slug, status: status }
      })
    );
  }

  function renderAllEventRoots() {
    var state = getState();
    state.roots.forEach(function (entry) {
      renderRootFromEntry(entry);
    });
    if (state.openModalSlug) {
      var activeEntry = state.roots.length ? state.roots[0] : null;
      if (activeEntry && activeEntry.cfg) renderBookingModal(activeEntry.cfg);
    }
    schedulePaidHoldCountdownTick();
  }

  function hasActivePaidHoldCountdown() {
    var state = getState();
    return Object.keys(state.bookingBySlug || {}).some(function (slug) {
      var booking = state.bookingBySlug[slug];
      return booking && booking.status === 'finalizing' && booking.expiresAt && isFutureIso(booking.expiresAt);
    });
  }

  function schedulePaidHoldCountdownTick() {
    var state = getState();
    if (!hasActivePaidHoldCountdown()) {
      if (state.paidHoldCountdownTimer) {
        window.clearTimeout(state.paidHoldCountdownTimer);
        state.paidHoldCountdownTimer = null;
      }
      return;
    }
    if (state.paidHoldCountdownTimer) return;
    state.paidHoldCountdownTimer = window.setTimeout(function () {
      state.paidHoldCountdownTimer = null;
      renderAllEventRoots();
    }, 1000);
  }

  function normalizeIntendedAction(value) {
    var action = safeText(value, '').toLowerCase();
    return action === 'register' || action === 'book' ? action : '';
  }

  function buildSafeReturnPathWithHash(slug, intendedAction) {
    var source = new URL(window.location.href);
    var safeUrl = new URL(source.pathname, source.origin);
    var safeSlug = toSafeEventSlug(slug);
    var safeAction = normalizeIntendedAction(intendedAction);
    var safeNamePattern = /^[A-Za-z0-9_.-]{1,64}$/;
    var sensitiveNamePattern = /(auth|cookie|password|secret|session|signature|token)/i;

    source.searchParams.forEach(function (value, name) {
      if (
        name === 'event' ||
        name === INTENDED_ACTION_PARAMETER ||
        !safeNamePattern.test(name) ||
        sensitiveNamePattern.test(name) ||
        typeof value !== 'string' ||
        value.length > 512 ||
        /[\u0000-\u001f\u007f]/.test(value)
      ) return;
      safeUrl.searchParams.append(name, value);
    });

    if (safeSlug) {
      safeUrl.searchParams.set('event', safeSlug);
      safeUrl.hash = 'event-' + safeSlug;
    } else {
      var safeHashId = readSafeEventHashId();
      if (safeHashId) safeUrl.hash = safeHashId;
    }
    if (safeAction) safeUrl.searchParams.set(INTENDED_ACTION_PARAMETER, safeAction);
    return safeUrl.pathname + safeUrl.search + safeUrl.hash;
  }

  function buildLoginHrefWithReturnUrl(loginUrl, slug, intendedAction) {
    var safeLoginUrl = allowedAllEventsUrl(loginUrl);
    if (!safeLoginUrl) return null;

    try {
      var parsed = new URL(safeLoginUrl, window.location.origin);
      if (parsed.origin !== window.location.origin) return null;
      var returnUrl = buildSafeReturnPathWithHash(slug, intendedAction);
      parsed.searchParams.set('return_url', returnUrl);
      return parsed.href;
    } catch (e) {
      return null;
    }
  }

  function readSafeEventHashId() {
    var rawHash = safeText(window.location.hash, '');
    if (!rawHash || rawHash.charAt(0) !== '#') return null;
    var decodedHash = rawHash;
    try {
      decodedHash = decodeURIComponent(rawHash);
    } catch (e) {}
    var hashId = decodedHash.slice(1).toLowerCase();
    return /^event-[a-z0-9]+(?:-[a-z0-9]+)*$/.test(hashId) ? hashId : null;
  }

  function scrollToEventHashTarget() {
    var safeId = readSafeEventHashId();
    if (!safeId) return;

    var target = document.getElementById(safeId);
    if (!target) return;

    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');

    if (target.scrollIntoView) {
      target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }

    if (target.focus) {
      try {
        target.focus({ preventScroll: true });
      } catch (e) {
        target.focus();
      }
    }
  }

  function sortEventsChronological(events) {
    return events.slice().sort(function (a, b) {
      var aDate = parseIsoDate(a && a.start_at);
      var bDate = parseIsoDate(b && b.start_at);
      var aTime = aDate ? aDate.getTime() : Number.MAX_SAFE_INTEGER;
      var bTime = bDate ? bDate.getTime() : Number.MAX_SAFE_INTEGER;
      return aTime - bTime;
    });
  }

  function mapCategoryLabel(category, cfg) {
    var key = safeText(category, '').toLowerCase();
    if (!key) return '';
    var labels = (cfg && cfg.i18n && cfg.i18n.categories) || DEFAULT_I18N.categories;
    return labels[key] || DEFAULT_I18N.categories.other;
  }

  function formatDateBadge(eventDto, locale, fallbackTz) {
    var start = parseIsoDate(eventDto.start_at);
    if (!start) return null;

    var tz = safeText(eventDto.timezone, fallbackTz || 'Europe/Vienna');

    try {
      var monthFmt = new Intl.DateTimeFormat(locale || 'de-AT', {
        month: 'short',
        timeZone: tz
      });
      var dayFmt = new Intl.DateTimeFormat(locale || 'de-AT', {
        day: '2-digit',
        timeZone: tz
      });
      return {
        monthShort: monthFmt.format(start).replace('.', ''),
        day: dayFmt.format(start)
      };
    } catch (e) {
      return null;
    }
  }

  function formatDateRange(eventDto, locale, fallbackTz) {
    var start = parseIsoDate(eventDto.start_at);
    if (!start) return '';

    var end = parseIsoDate(eventDto.end_at);
    var tz = safeText(eventDto.timezone, fallbackTz || 'Europe/Vienna');

    try {
      var dateFmt = new Intl.DateTimeFormat(locale || 'de-AT', {
        weekday: 'short',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: tz
      });
      var timeFmt = new Intl.DateTimeFormat(locale || 'de-AT', {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: tz
      });

      var startText = dateFmt.format(start) + ', ' + timeFmt.format(start);
      if (!end) return startText;

      return startText + ' – ' + timeFmt.format(end);
    } catch (e) {
      return '';
    }
  }

  function renderState(root, kind, message) {
    root.innerHTML = '';
    var state = document.createElement('div');
    state.className = 'fh-events__state';
    state.setAttribute('data-fh-events-state', kind);
    state.textContent = message;
    root.appendChild(state);
  }

  function revealDrawerRail(root) {
    var rail = root && root.closest ? root.closest('[data-fh-events-rail]') : null;
    if (!rail) return;
    rail.classList.remove('fh-events-rail--runtime-disabled');
    rail.hidden = false;
    rail.style.display = '';
    if ('inert' in rail) rail.inert = false;
    if (root) root.hidden = false;

    var panel = rail.querySelector('[data-fh-events-rail-panel]');
    if (panel) {
      panel.hidden = false;
      var isOpen = rail.classList.contains('is-open');
      if ('inert' in panel) panel.inert = !isOpen;
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }
  }

  function hideDrawerRail(root) {
    var rail = root && root.closest ? root.closest('[data-fh-events-rail]') : null;
    if (!rail) return;
    rail.classList.add('fh-events-rail--runtime-disabled');
    rail.hidden = true;
    rail.style.display = 'none';
    rail.classList.remove('is-open');
    if (root) {
      root.hidden = true;
      root.innerHTML = '';
    }
    var toggle = rail.querySelector('[data-fh-events-rail-toggle]');
    var panel = rail.querySelector('[data-fh-events-rail-panel]');
    var backdrop = rail.querySelector('[data-fh-events-rail-backdrop]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
      panel.hidden = true;
      if ('inert' in panel) panel.inert = true;
    }
    if (backdrop) backdrop.hidden = true;
    if ('inert' in rail) rail.inert = true;
  }

  function renderMaintenanceState(root, message) {
    renderState(root, 'maintenance', safeText(message, t(null, 'maintenance')));
  }

  function updateAvailabilityText(item, eventDto) {
    if (!item || !eventDto) return;
    var avail = item.querySelector('[data-fh-events-availability]');
    if (!avail) return;

    var summary = getAvailabilitySummary(eventDto);
    if (!summary) return;

    avail.textContent = DEFAULT_I18N.availability_label + ': ' + summary.available + ' / ' + summary.total;
  }

  function submitFreeBookingBySlug(slug, cfg) {
    var state = getState();
    var eventDto = slug ? state.eventsBySlug[slug] : null;
    var booking = getBookingState(slug);
    if (!eventDto || !cfg || !booking || booking.pending) return;

    if (buildEventViewModel(eventDto, cfg).customerState === 'event_ended') {
      renderAllEventRoots();
      return;
    }

    var bookingUrl = buildFreeBookingUrl(eventDto, cfg);
    if (!bookingUrl) {
      setBookingState(slug, { errorMessage: t(cfg, 'booking_unavailable'), infoMessage: '' });
      renderAllEventRoots();
      return;
    }

    setBookingState(slug, {
      pending: true,
      infoMessage: t(cfg, 'booking_progress'),
      errorMessage: ''
    });
    renderAllEventRoots();

    appProxyPostJson(bookingUrl, {})
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return null;
          })
          .then(function (payload) {
            return { status: res.status, ok: res.ok, payload: payload };
          });
      })
      .then(function (result) {
        var payload = result && result.payload;
        var data = payload && payload.data ? payload.data : null;
        var reason = safeText(data && data.reason, '');

        if (!reason) {
          if (result.status === 401) reason = 'auth_required';
          else if (result.status === 409) reason = 'full';
        }

        if (reason === 'reserved') {
          setBookingState(slug, {
            status: 'reserved',
            hydrated: true,
            pending: false,
            infoMessage: t(cfg, 'booking_success'),
            errorMessage: '',
            lastAction: 'reserve',
            successAcknowledged: false
          });
          trackAnalytics('free_registration_completed', {
            event_slug: slug,
            surface: 'booking_modal',
            booking_mode: 'free',
            customer_state: 'reserved',
            outcome: 'completed'
          });
        } else if (reason === 'already_reserved') {
          setBookingState(slug, {
            status: 'reserved',
            hydrated: true,
            pending: false,
            infoMessage: t(cfg, 'booking_already'),
            errorMessage: '',
            lastAction: 'reserve',
            successAcknowledged: false
          });
        } else if (reason === 'event_ended') {
          setBookingState(slug, {
            status: 'event_ended', hydrated: true, pending: false,
            infoMessage: '', errorMessage: t(cfg, 'event_ended')
          });
        } else if (reason === 'full') {
          setBookingState(slug, {
            status: 'full',
            hydrated: true,
            pending: false,
            infoMessage: '',
            errorMessage: t(cfg, 'booking_full')
          });
        } else if (reason === 'auth_required') {
          setBookingState(slug, {
            status: 'error',
            pending: false,
            infoMessage: '',
            errorMessage: t(cfg, 'auth_retry')
          });
        } else {
          setBookingState(slug, {
            status: 'error',
            pending: false,
            infoMessage: '',
            errorMessage: t(cfg, 'booking_error')
          });
        }

        var eventUpdate = data && data.event ? data.event : null;
        if (eventUpdate) patchEventCapacity(slug, eventUpdate);
        emitBookingStateChanged(slug, getBookingState(slug).status);
        renderAllEventRoots();
      })
      .catch(function () {
        setBookingState(slug, {
          status: 'error',
          pending: false,
          infoMessage: '',
          errorMessage: t(cfg, 'booking_error')
        });
        renderAllEventRoots();
      })
      .finally(function () {
        var latest = getBookingState(slug);
        if (latest && latest.pending) setBookingState(slug, { pending: false });
        renderAllEventRoots();
      });
  }

  function cancelFreeBookingBySlug(slug, cfg) {
    var state = getState();
    var eventDto = slug ? state.eventsBySlug[slug] : null;
    var booking = getBookingState(slug);
    if (!eventDto || !cfg || !booking || booking.pending) return;

    var cancelUrl = buildFreeBookingCancelUrl(eventDto, cfg);
    if (!cancelUrl) {
      setBookingState(slug, { errorMessage: t(cfg, 'cancel_unavailable'), infoMessage: '' });
      renderAllEventRoots();
      return;
    }

    setBookingState(slug, {
      pending: true,
      infoMessage: t(cfg, 'cancel_progress'),
      errorMessage: ''
    });
    renderAllEventRoots();

    appProxyPostJson(cancelUrl, {})
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return null;
          })
          .then(function (payload) {
            return { status: res.status, ok: res.ok, payload: payload };
          });
      })
      .then(function (result) {
        var payload = result && result.payload;
        var data = payload && payload.data ? payload.data : null;
        var reason = safeText(data && data.reason, '');

        if (!reason) {
          if (result.status === 401) reason = 'auth_required';
        }

        if (reason === 'cancelled') {
          setBookingState(slug, {
            status: 'cancelled_local',
            hydrated: true,
            pending: false,
            infoMessage: t(cfg, 'cancel_success'),
            errorMessage: '',
            lastAction: 'cancel'
          });
          trackAnalytics('booking_cancelled', {
            event_slug: slug,
            surface: 'booking_modal',
            booking_mode: 'free',
            customer_state: 'cancelled_local',
            outcome: 'completed'
          });
        } else if (reason === 'not_reserved') {
          setBookingState(slug, {
            status: 'cancelled_local',
            hydrated: true,
            pending: false,
            infoMessage: t(cfg, 'cancel_not_reserved'),
            errorMessage: '',
            lastAction: 'cancel'
          });
        } else if (reason === 'auth_required') {
          setBookingState(slug, {
            status: 'error',
            pending: false,
            infoMessage: '',
            errorMessage: t(cfg, 'auth_retry')
          });
        } else {
          setBookingState(slug, {
            status: 'error',
            pending: false,
            infoMessage: '',
            errorMessage: t(cfg, 'cancel_error')
          });
        }

        var eventUpdate = data && data.event ? data.event : null;
        if (eventUpdate) patchEventCapacity(slug, eventUpdate);
        emitBookingStateChanged(slug, getBookingState(slug).status);
        renderAllEventRoots();
      })
      .catch(function () {
        setBookingState(slug, {
          status: 'error',
          pending: false,
          infoMessage: '',
          errorMessage: t(cfg, 'cancel_error')
        });
        renderAllEventRoots();
      })
      .finally(function () {
        var latest = getBookingState(slug);
        if (latest && latest.pending) setBookingState(slug, { pending: false });
        renderAllEventRoots();
      });
  }

  function generatePaidIdempotencyKey() {
    var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789._:-';
    var key = 'fh_evt_' + Date.now().toString(36) + '_';
    var bytes = null;
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      bytes = new Uint8Array(24);
      window.crypto.getRandomValues(bytes);
    }

    for (var i = 0; i < 24; i += 1) {
      var n = bytes ? bytes[i] : Math.floor(Math.random() * 256);
      key += alphabet.charAt(n % alphabet.length);
    }

    return key.slice(0, 128);
  }

  function generatePaidProofRunId() {
    var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var key = 'fh-proof-' + Date.now().toString(36) + '-';
    var bytes = null;
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
    }

    for (var i = 0; i < 16; i += 1) {
      var n = bytes ? bytes[i] : Math.floor(Math.random() * 256);
      key += alphabet.charAt(n % alphabet.length);
    }

    return key.slice(0, 96);
  }

  function parseJsonResponse(res) {
    return res
      .json()
      .catch(function () {
        return null;
      })
      .then(function (payload) {
        return { status: res.status, ok: res.ok, payload: payload };
      });
  }

  function postJson(url, body) {
    return appProxyPostJson(url, body).then(parseJsonResponse);
  }

  function getRiseCartSurface() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getRiseCartSurfaceSections(cartSurface) {
    if (!cartSurface || typeof cartSurface.getSectionsToRender !== 'function') return [];

    try {
      return cartSurface.getSectionsToRender()
        .map(function (section) {
          return safeText(section && section.id, '');
        })
        .filter(function (id) {
          return !!id;
        });
    } catch (error) {
      return [];
    }
  }

  function readIntendedAction() {
    var values = new URLSearchParams(window.location.search).getAll(INTENDED_ACTION_PARAMETER);
    if (values.length !== 1) return '';
    return normalizeIntendedAction(values[0]);
  }

  function clearIntendedActionFromUrl() {
    try {
      var current = new URL(window.location.href);
      current.searchParams.delete(INTENDED_ACTION_PARAMETER);
      window.history.replaceState(
        window.history.state,
        '',
        current.pathname + current.search + current.hash
      );
    } catch (e) {}
  }

  function showRiseCartSurfaceAfterPaidAdd(cartResult) {
    var cartSurface = getRiseCartSurface();
    var payload = cartResult && cartResult.payload ? cartResult.payload : null;
    if (cartSurface && payload && payload.sections && typeof cartSurface.renderContents === 'function') {
      if (typeof cartSurface.setActiveElement === 'function') cartSurface.setActiveElement(document.activeElement);
      cartSurface.renderContents(payload);
      return true;
    }

    var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    window.location.assign(cartUrl);
    return false;
  }

  function addPaidTicketToCart(variantId, cartProperties) {
    var cartSurface = getRiseCartSurface();
    var sections = getRiseCartSurfaceSections(cartSurface);
    var payload = {
      id: variantId,
      quantity: 1,
      properties: cartProperties
    };
    if (sections.length) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }
    if (cartSurface && typeof cartSurface.setActiveElement === 'function') cartSurface.setActiveElement(document.activeElement);

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(parseJsonResponse);
  }

  function paidCheckoutPrecheckError(reason, precheckReason) {
    var error = new Error(reason || 'checkout_precheck_blocked');
    error.fhReason = reason || 'checkout_precheck_blocked';
    error.fhPrecheckReason = safeText(precheckReason, '');
    error.checkoutPrecheckBlocked = true;
    error.afterCartAdd = true;
    return error;
  }

  function getPaidCheckoutPrecheckMessage(cfg, reason) {
    var normalizedReason = safeText(reason, '');
    if (normalizedReason === 'invalid_quantity' || normalizedReason === 'duplicate_hold' || normalizedReason === 'duplicate_prepare') {
      return PAID_SINGLE_SEAT_MESSAGE;
    }
    if (normalizedReason === 'checkout_precheck_network_failed' || normalizedReason === 'checkout_precheck_unavailable' || normalizedReason === 'internal_error') {
      return t(cfg, 'paid_precheck_error');
    }
    return t(cfg, 'paid_precheck_stale');
  }

  function submitPaidBookingBySlug(slug, cfg) {
    var state = getState();
    var eventDto = slug ? state.eventsBySlug[slug] : null;
    var booking = getBookingState(slug);
    if (!eventDto || !cfg || !booking || booking.pending) return;

    var variantId = toSafeShopifyVariantId(eventDto.shopify_variant_id);
    var prepareUrl = buildPaidPrepareUrl(eventDto, cfg);
    var priceSnapshot = getPaidPriceSnapshot(eventDto, cfg);
    if (!cfg.customerLoggedIn) {
      setBookingState(slug, { errorMessage: t(cfg, 'paid_login_cta'), infoMessage: '' });
      renderAllEventRoots();
      return;
    }
    if (priceSnapshot.missingRequired) {
      setBookingState(slug, { errorMessage: t(cfg, 'paid_price_missing'), infoMessage: '' });
      renderAllEventRoots();
      return;
    }
    if (!variantId || !prepareUrl) {
      setBookingState(slug, { errorMessage: t(cfg, 'paid_variant_unavailable'), infoMessage: '' });
      renderAllEventRoots();
      return;
    }

    var idempotencyKey = generatePaidIdempotencyKey();
    setBookingState(slug, {
      status: 'paid_preparing',
      expiresAt: '',
      pending: true,
      infoMessage: t(cfg, 'paid_confirm_progress'),
      errorMessage: ''
    });
    renderAllEventRoots();

    postJson(prepareUrl, { quantity: 1, idempotency_key: idempotencyKey })
      .then(function (prepareResult) {
        var prepareData = prepareResult && prepareResult.payload && prepareResult.payload.data ? prepareResult.payload.data : null;
        var reason = safeText(prepareData && prepareData.reason, '');
        if (!reason && prepareResult.status === 409) reason = 'capacity_unavailable';
        if (!prepareResult.ok || (reason !== 'prepared' && reason !== 'already_prepared')) {
          var error = new Error(reason || 'prepare_failed');
          error.fhReason = reason || 'prepare_failed';
          throw error;
        }

        var prepareId = toSafeLinkageId(prepareData && prepareData.prepare_id);
        var holdId = toSafeLinkageId(prepareData && prepareData.hold_id);
        var expiresAt = normalizeCustomerBookingExpiresAt(prepareData && prepareData.expires_at);
        var eventSlug = toSafeEventSlug((prepareData && prepareData.event_slug) || slug);
        if (!prepareId || !holdId || eventSlug !== slug) {
          var invalid = new Error('invalid_prepare_payload');
          invalid.fhReason = 'invalid_prepare_payload';
          throw invalid;
        }

        trackAnalytics('paid_hold_started', {
          event_slug: slug,
          surface: 'booking_modal',
          booking_mode: 'shopify_checkout',
          customer_state: 'paid_preparing',
          outcome: 'prepared'
        });

        var proofRunId = generatePaidProofRunId();
        var cartProperties = {
          _fh_source: 'event_booking',
          _fh_event_slug: slug,
          _fh_prepare_id: prepareId,
          _fh_hold_id: holdId
        };
        var shopifyCartProperties = Object.assign({}, cartProperties, {
          _fh_proof_run_id: proofRunId,
          _fh_variant_id: variantId,
          _fh_event_title: safeCartContextText(eventDto.title, 160),
          _fh_event_start_at: safeCartContextIso(eventDto.start_at),
          _fh_event_end_at: safeCartContextIso(eventDto.end_at),
          _fh_event_location: safeCartContextText(eventDto.location_text, 160),
          _fh_hold_expires_at: safeCartContextIso(expiresAt)
        });

        setBookingState(slug, {
          status: 'paid_cart_adding',
          expiresAt: expiresAt,
          pending: true,
          infoMessage: t(cfg, 'paid_cart_progress'),
          errorMessage: ''
        });
        renderAllEventRoots();

        return addPaidTicketToCart(variantId, shopifyCartProperties).then(function (cartResult) {
          if (!cartResult || !cartResult.ok) {
            var cartError = new Error('cart_add_failed');
            cartError.fhReason = 'cart_add_failed';
            cartError.preparedHold = { event_slug: slug, prepare_id: prepareId, hold_id: holdId };
            throw cartError;
          }
          setBookingState(slug, {
            status: 'paid_cart_added',
            expiresAt: '',
            hydrated: true,
            pending: false,
            infoMessage: t(cfg, 'paid_cart_added'),
            errorMessage: '',
            lastAction: 'paid_cart_add'
          });
          trackAnalytics('event_added_to_cart', {
            event_slug: slug,
            surface: 'booking_modal',
            booking_mode: 'shopify_checkout',
            customer_state: 'paid_cart_added',
            outcome: 'completed'
          });
          emitBookingStateChanged(slug, 'paid_cart_added');
          renderAllEventRoots();
          closeBookingModal();
          showRiseCartSurfaceAfterPaidAdd(cartResult);
          return { prepareId: prepareId, cartProperties: cartProperties, cartQuantity: toFiniteNumber(cartResult.payload && cartResult.payload.quantity) };
        });
      })
      .then(function (linkContext) {
        var checkoutLinkUrl = buildPaidCheckoutLinkUrl(eventDto, cfg, linkContext.prepareId);
        if (!checkoutLinkUrl) {
          var linkUrlError = new Error('checkout_link_unavailable');
          linkUrlError.fhReason = 'checkout_link_unavailable';
          throw linkUrlError;
        }
        return postJson(checkoutLinkUrl, { properties_confirmed: linkContext.cartProperties }).catch(function (error) {
          error.afterCartAdd = true;
          error.fhReason = 'checkout_link_failed';
          throw error;
        }).then(function (linkResult) {
          return { linkResult: linkResult, linkContext: linkContext };
        });
      })
      .then(function (linked) {
        var linkResult = linked && linked.linkResult;
        var linkContext = linked && linked.linkContext;
        var linkData = linkResult && linkResult.payload && linkResult.payload.data ? linkResult.payload.data : null;
        var reason = safeText(linkData && linkData.reason, '');
        if (!linkResult.ok || (reason !== 'checkout_linked' && reason !== 'already_checkout_linked')) {
          var linkError = new Error(reason || 'checkout_link_failed');
          linkError.fhReason = 'checkout_link_failed';
          linkError.afterCartAdd = true;
          throw linkError;
        }

        return linkContext;
      })
      .then(function () {
        setBookingState(slug, {
          status: 'paid_cart_added',
          expiresAt: '',
          hydrated: true,
          pending: false,
          infoMessage: t(cfg, 'paid_cart_added'),
          errorMessage: '',
          lastAction: 'paid_cart_add'
        });
        emitBookingStateChanged(slug, 'paid_cart_added');
        renderAllEventRoots();
      })
      .catch(function (error) {
        var reason = safeText(error && error.fhReason, '');
        var precheckReason = safeText(error && error.fhPrecheckReason, reason);
        var checkoutPrecheckBlocked = !!(error && error.checkoutPrecheckBlocked);
        var afterCartAdd = !!(error && error.afterCartAdd);
        var message = t(cfg, 'paid_cart_error');
        var status = 'error';

        if (checkoutPrecheckBlocked) {
          status = 'paid_checkout_precheck_failed';
          message = getPaidCheckoutPrecheckMessage(cfg, reason === 'checkout_precheck_blocked' ? precheckReason : reason);
        } else if (afterCartAdd || reason === 'checkout_link_unavailable') {
          status = 'paid_checkout_link_failed';
          message = t(cfg, 'paid_link_fallback');
        } else if (reason === 'capacity_unavailable') {
          message = t(cfg, 'paid_capacity_unavailable');
        } else if (reason === 'auth_required' || reason === 'session_required') {
          message = t(cfg, 'auth_retry');
        } else if (reason === 'cart_add_failed') {
          status = 'not_registered';
          message = t(cfg, 'paid_cart_error');
        }

        var renderFailureState = function () {
          if (reason === 'cart_add_failed') {
            eventDto.customer_booking_status = '';
            eventDto.customer_booking_expires_at = '';
          }
          setBookingState(slug, {
            status: status,
            expiresAt: '',
            hydrated: reason === 'cart_add_failed' ? true : booking.hydrated,
            pending: false,
            infoMessage: !checkoutPrecheckBlocked && (afterCartAdd || reason === 'checkout_link_unavailable') ? message : '',
            errorMessage: checkoutPrecheckBlocked || (!afterCartAdd && reason !== 'checkout_link_unavailable') ? message : ''
          });
          trackAnalytics('booking_error_shown', {
            event_slug: slug,
            surface: afterCartAdd ? 'cart' : 'booking_modal',
            booking_mode: 'shopify_checkout',
            customer_state: status,
            reason: reason || 'unknown'
          });
          renderAllEventRoots();
        };

        if (reason === 'cart_add_failed') {
          return releasePreparedPaidBookingHold(error && error.preparedHold, (cfg && cfg.endpoint) || '/apps/fh-bobbel/events').then(renderFailureState);
        }

        renderFailureState();
      })
      .finally(function () {
        var latest = getBookingState(slug);
        if (latest && latest.pending) setBookingState(slug, { pending: false });
        renderAllEventRoots();
      });
  }

  function createCta(eventDto, cfg, opts) {
    var mode = safeText(eventDto.booking_mode, 'none');
    var label = safeText(eventDto.cta_label, '');
    var viewModel = buildEventViewModel(eventDto, cfg);

    if (mode === 'external') {
      var safeUrl = allowedExternalUrl(eventDto.external_url);
      if (!safeUrl) return null;

      var a = document.createElement('a');
      a.className = 'fh-events__cta';
      a.href = safeUrl;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.textContent = label || t(cfg, 'external_more');
      return a;
    }

    if (mode === 'none') {
      if (!label) return null;
      var safeSlug = toSafeEventSlug(eventDto.slug);
      var detailsHref = buildDetailsHref(cfg && cfg.allEventsUrl, safeSlug);
      if (detailsHref) {
        var detailsLink = document.createElement('a');
        detailsLink.className = 'fh-events__cta';
        detailsLink.href = detailsHref;
        detailsLink.textContent = label;
        return detailsLink;
      }
      var noneLabel = document.createElement('span');
      noneLabel.className = 'fh-events__cta fh-events__cta--disabled';
      noneLabel.textContent = label;
      return noneLabel;
    }

    if (mode === 'free') {
      if (viewModel.ctaKind === 'login') {
        var loginLink = document.createElement('a');
        loginLink.className = 'fh-events__cta';
        loginLink.textContent = viewModel.ctaLabel;
        var freeLoginSlug = toSafeEventSlug(eventDto.slug);
        var initialLoginHref = buildLoginHrefWithReturnUrl(cfg.accountLoginUrl, freeLoginSlug, 'register');
        if (initialLoginHref) {
          loginLink.href = initialLoginHref;
        } else {
          loginLink.href = safeText(cfg.accountLoginUrl, '/account/login');
        }
        trackAnalytics('login_required_shown', bookingAnalyticsContext(eventDto, cfg, viewModel, 'login'), {
          once: true,
          dedupeKey: 'free:' + freeLoginSlug + ':' + analyticsSurface(cfg)
        });
        loginLink.addEventListener('click', function () {
          trackAnalytics('booking_cta_clicked', bookingAnalyticsContext(eventDto, cfg, viewModel, 'login'));
          var refreshedHref = buildLoginHrefWithReturnUrl(cfg.accountLoginUrl, freeLoginSlug, 'register');
          if (refreshedHref) loginLink.href = refreshedHref;
        });
        return loginLink;
      }

      var freeButton = document.createElement('button');
      freeButton.type = 'button';
      freeButton.className = 'fh-events__cta fh-events__cta--button';
      freeButton.textContent = viewModel.ctaLabel;
      freeButton.disabled = !!viewModel.ctaDisabled;
      if (viewModel.ctaKind === 'modal' || viewModel.ctaKind === 'manage') {
        freeButton.addEventListener('click', function (event) {
          trackAnalytics('booking_cta_clicked', bookingAnalyticsContext(
            eventDto,
            cfg,
            viewModel,
            viewModel.ctaKind === 'manage' ? 'manage_registration' : 'register'
          ));
          if (opts && typeof opts.onOpenBookingModal === 'function') {
            opts.onOpenBookingModal(event && event.currentTarget ? event.currentTarget : freeButton);
          }
        });
      }
      return freeButton;
    }

    if (mode === 'shopify_checkout') {
      if (viewModel.ctaKind === 'login') {
        var paidLoginLink = document.createElement('a');
        paidLoginLink.className = 'fh-events__cta';
        paidLoginLink.textContent = viewModel.ctaLabel;
        var paidLoginSlug = toSafeEventSlug(eventDto.slug);
        var paidLoginHref = buildLoginHrefWithReturnUrl(cfg.accountLoginUrl, paidLoginSlug, 'book');
        paidLoginLink.href = paidLoginHref || safeText(cfg.accountLoginUrl, '/account/login');
        trackAnalytics('login_required_shown', bookingAnalyticsContext(eventDto, cfg, viewModel, 'login'), {
          once: true,
          dedupeKey: 'paid:' + paidLoginSlug + ':' + analyticsSurface(cfg)
        });
        paidLoginLink.addEventListener('click', function () {
          trackAnalytics('booking_cta_clicked', bookingAnalyticsContext(eventDto, cfg, viewModel, 'login'));
          var refreshedPaidLoginHref = buildLoginHrefWithReturnUrl(cfg.accountLoginUrl, paidLoginSlug, 'book');
          if (refreshedPaidLoginHref) paidLoginLink.href = refreshedPaidLoginHref;
        });
        return paidLoginLink;
      }

      var paidButton = document.createElement('button');
      paidButton.type = 'button';
      paidButton.className = 'fh-events__cta fh-events__cta--button';
      paidButton.textContent = viewModel.ctaLabel;
      paidButton.disabled = !!viewModel.ctaDisabled;
      if (viewModel.ctaKind === 'paid_confirm') {
        paidButton.addEventListener('click', function (event) {
          trackAnalytics('booking_cta_clicked', bookingAnalyticsContext(eventDto, cfg, viewModel, 'book'));
          if (opts && typeof opts.onOpenBookingModal === 'function') {
            opts.onOpenBookingModal(event && event.currentTarget ? event.currentTarget : paidButton);
          }
        });
      }
      return paidButton;
    }

    return null;
  }

  function getStructuredEventContent(eventDto) {
    var api = window.FunnyHooksEventsStructuredContent;
    if (api && typeof api.buildStructuredEventContent === 'function') {
      return api.buildStructuredEventContent(eventDto || {});
    }

    var description = stripHtmlToText(safeText(eventDto && eventDto.description_html, ''));
    return {
      listSummary: description.length > 160 ? description.slice(0, 157).trim() + '...' : description,
      detailDescription: { mode: 'PLAIN_TEXT', value: description },
      image: { status: 'FALLBACK', src: '', alt: '' },
      optionalSections: []
    };
  }

  function getDiscoveryPrice(eventDto, viewModel, cfg) {
    var mode = safeText(eventDto && eventDto.booking_mode, 'none');
    if (mode === 'free') return t(cfg, 'free_label');
    if (viewModel && viewModel.priceDisplay) return viewModel.priceDisplay;
    var explicitPrice = safePublicPriceDisplay(eventDto && eventDto.price_display);
    if (explicitPrice) return explicitPrice;
    if (mode === 'shopify_checkout') return t(cfg, 'paid_price_missing');
    return t(cfg, 'free_label');
  }

  function getFriendlyAvailability(viewModel, cfg) {
    if (viewModel && viewModel.isEndedFreeEvent) return '';
    var availability = viewModel && viewModel.availability;
    if (!availability) return t(cfg, 'soon_bookable');
    if (availability.available <= 0) return t(cfg, 'sold_out');
    if (availability.available <= 3) return t(cfg, 'few_places_available');
    return t(cfg, 'places_available');
  }

  function appendTextElement(parent, tagName, className, text, attributeName) {
    if (!parent || !text) return null;
    var element = document.createElement(tagName);
    element.className = className;
    if (attributeName) element.setAttribute(attributeName, '');
    element.textContent = text;
    parent.appendChild(element);
    return element;
  }

  function appendDetailField(parent, label, content, selector, kind) {
    if (!parent || !content) return null;
    var field = document.createElement('section');
    field.className = 'fh-events__detail-field';
    if (selector) field.setAttribute(selector, '');

    appendTextElement(field, 'h2', 'fh-events__detail-field-title', label);
    if (kind === 'list' && Array.isArray(content)) {
      var list = document.createElement('ul');
      content.forEach(function (value) {
        appendTextElement(list, 'li', '', value);
      });
      field.appendChild(list);
    } else {
      appendTextElement(field, 'p', '', content);
    }
    parent.appendChild(field);
    return field;
  }

  function buildBookingAction(eventDto, cfg) {
    var slug = toSafeEventSlug(eventDto && eventDto.slug);
    var cta = createCta(eventDto, cfg, {
      onOpenBookingModal: function (opener) {
        openBookingModal(slug, cfg, opener);
      }
    });
    if (cta) cta.setAttribute('data-fh-event-booking-action', '');
    return cta;
  }

  function resumeIntendedAction(root, events, cfg) {
    if (!root || !cfg || !cfg.customerLoggedIn || cfg.displayMode !== 'detail') return;
    var intendedAction = readIntendedAction();
    if (!intendedAction || !events || events.length !== 1) return;
    var eventDto = events[0];
    var slug = toSafeEventSlug(eventDto && eventDto.slug);
    var mode = safeText(eventDto && eventDto.booking_mode, 'none');
    var actionMatchesMode = (intendedAction === 'register' && mode === 'free') ||
      (intendedAction === 'book' && mode === 'shopify_checkout');
    if (!slug || !actionMatchesMode) return;

    var state = getState();
    var intentKey = slug + ':' + intendedAction;
    if (state.resumedIntentKey === intentKey) return;
    state.resumedIntentKey = intentKey;
    clearIntendedActionFromUrl();

    var opener = root.querySelector('[data-fh-event-booking-action]');
    openBookingModal(slug, cfg, opener || null);
  }

  function renderDiscoveryEvents(root, events, cfg) {
    root.innerHTML = '';
    var isDrawer = cfg.surface === 'drawer';
    var list = document.createElement('div');
    list.className = 'fh-events__list' + (isDrawer ? ' fh-events__list--drawer' : '');
    list.setAttribute(isDrawer ? 'data-fh-event-drawer-list' : 'data-fh-event-catalogue-list', '');

    sortEventsChronological(events).forEach(function (eventDto) {
      var slug = toSafeEventSlug(eventDto && eventDto.slug);
      if (!slug) return;
      var viewModel = buildEventViewModel(eventDto, cfg);
      var content = getStructuredEventContent(eventDto);
      var item = document.createElement('article');
      item.className = 'fh-events__item ' + (isDrawer ? 'fh-events__item--drawer' : 'fh-events__item--catalogue');
      if (!isDrawer) item.id = 'event-' + slug;
      item.setAttribute('data-fh-event-card', '');
      item.setAttribute(isDrawer ? 'data-fh-event-drawer-card' : 'data-fh-event-list-card', '');
      item.setAttribute('data-fh-event-slug', slug);

      var title = appendTextElement(item, 'h3', 'fh-events__title', normalizeDisplayText(safeText(eventDto.title, 'Event')));
      if (title) title.setAttribute('data-fh-event-title', '');

      var dateLine = formatDateRange(eventDto, cfg.locale, cfg.fallbackTz);
      var date = appendTextElement(item, 'time', 'fh-events__meta', dateLine);
      if (date) {
        date.setAttribute('data-fh-event-date', '');
        date.setAttribute('datetime', safeText(eventDto.start_at, ''));
      }

      var location = normalizeDisplayText(eventDto.location_text);
      var locationLine = appendTextElement(item, 'p', 'fh-events__meta', location);
      if (locationLine) locationLine.setAttribute('data-fh-event-location', '');

      var price = appendTextElement(item, 'p', 'fh-events__price-line', getDiscoveryPrice(eventDto, viewModel, cfg));
      if (price) price.setAttribute('data-fh-event-price', '');

      var availability = appendTextElement(item, 'p', 'fh-events__availability', getFriendlyAvailability(viewModel, cfg));
      if (availability) availability.setAttribute('data-fh-event-availability', '');

      if (!isDrawer) {
        var summary = appendTextElement(item, 'p', 'fh-events__catalogue-summary', content.listSummary);
        if (summary) summary.setAttribute('data-fh-event-summary', '');
      }

      var href = buildDetailsHref(cfg.allEventsUrl || window.location.pathname, slug);
      if (href) {
        var link = document.createElement('a');
        link.className = isDrawer ? 'fh-events__drawer-action' : 'fh-events__catalogue-action';
        link.href = href;
        link.textContent = t(cfg, 'view_event');
        link.setAttribute('data-fh-event-view-link', '');
        item.appendChild(link);
      }

      list.appendChild(item);
    });

    root.appendChild(list);
    if (!isDrawer) {
      trackAnalytics('event_list_viewed', {
        surface: 'catalogue',
        item_count: list.childElementCount
      }, { once: true, dedupeKey: window.location.pathname + window.location.search });
    }
    var allEventsHref = allowedAllEventsUrl(cfg.allEventsUrl);
    if (allEventsHref && isDrawer) {
      var footer = document.createElement('div');
      footer.className = 'fh-events__footer';
      var allEventsLink = document.createElement('a');
      allEventsLink.className = 'fh-events__all-events-link';
      allEventsLink.href = allEventsHref;
      allEventsLink.textContent = t(cfg, 'all_events');
      allEventsLink.setAttribute('data-fh-event-all-events-link', '');
      footer.appendChild(allEventsLink);
      root.appendChild(footer);
    }
  }

  function renderDetailEvents(root, events, cfg) {
    root.innerHTML = '';
    var eventDto = sortEventsChronological(events)[0];
    if (!eventDto) return;
    var slug = toSafeEventSlug(eventDto.slug);
    var viewModel = buildEventViewModel(eventDto, cfg);
    var content = getStructuredEventContent(eventDto);
    var item = document.createElement('article');
    item.className = 'fh-events__item fh-events__item--detail';
    item.setAttribute('data-fh-event-card', '');
    item.setAttribute('data-fh-event-detail', '');
    if (slug) {
      item.id = 'event-' + slug;
      item.setAttribute('data-fh-event-slug', slug);
    }

    var layout = document.createElement('div');
    layout.className = 'fh-events__detail-layout';

    var media = document.createElement('div');
    media.className = 'fh-events__detail-media';
    if (content.image && content.image.status === 'AVAILABLE') {
      var image = document.createElement('img');
      image.className = 'fh-events__detail-image';
      image.src = content.image.src;
      image.alt = content.image.alt || normalizeDisplayText(safeText(eventDto.title, 'Event'));
      image.loading = 'eager';
      image.setAttribute('data-fh-event-detail-image', '');
      image.addEventListener('error', function () {
        media.innerHTML = '';
        var fallback = appendTextElement(media, 'div', 'fh-events__detail-image-fallback', t(cfg, 'event_image_fallback'));
        if (fallback) {
          fallback.setAttribute('role', 'img');
          fallback.setAttribute('aria-label', t(cfg, 'event_image_fallback'));
          fallback.setAttribute('data-fh-event-detail-image-fallback', '');
        }
      });
      media.appendChild(image);
    } else {
      var imageFallback = appendTextElement(media, 'div', 'fh-events__detail-image-fallback', t(cfg, 'event_image_fallback'));
      if (imageFallback) {
        imageFallback.setAttribute('role', 'img');
        imageFallback.setAttribute('aria-label', t(cfg, 'event_image_fallback'));
        imageFallback.setAttribute('data-fh-event-detail-image-fallback', '');
      }
    }
    var main = document.createElement('div');
    main.className = 'fh-events__detail-main';
    var title = appendTextElement(main, 'h1', 'fh-events__title', normalizeDisplayText(safeText(eventDto.title, 'Event')));
    if (title) title.setAttribute('data-fh-event-detail-title', '');

    var dateLine = formatDateRange(eventDto, cfg.locale, cfg.fallbackTz);
    var date = appendTextElement(main, 'time', 'fh-events__meta', dateLine);
    if (date) {
      date.setAttribute('data-fh-event-detail-date', '');
      date.setAttribute('datetime', safeText(eventDto.start_at, ''));
    }
    var location = appendTextElement(main, 'p', 'fh-events__meta', normalizeDisplayText(eventDto.location_text));
    if (location) location.setAttribute('data-fh-event-detail-location', '');

    var detailBody = document.createElement('div');
    detailBody.className = 'fh-events__detail-body';
    var detailDescription = content.detailDescription && safeText(content.detailDescription.value, '');
    var description = appendTextElement(detailBody, 'div', 'fh-events__detail-description', detailDescription);
    if (description) description.setAttribute('data-fh-event-detail-description', '');

    var fields = document.createElement('div');
    fields.className = 'fh-events__detail-fields';
    var fieldSelectors = {
      included_items: 'data-fh-event-detail-included',
      what_to_bring: 'data-fh-event-detail-bring',
      audience: 'data-fh-event-detail-audience',
      cancellation_policy: 'data-fh-event-detail-cancellation',
      contact: 'data-fh-event-detail-contact'
    };
    var fieldLabels = {
      included_items: t(cfg, 'included_items'),
      what_to_bring: t(cfg, 'what_to_bring'),
      audience: t(cfg, 'audience'),
      cancellation_policy: t(cfg, 'cancellation_policy'),
      contact: t(cfg, 'contact')
    };
    var hasContact = false;
    (content.optionalSections || []).forEach(function (section) {
      if (!section || !fieldSelectors[section.key]) return;
      if (section.key === 'contact') hasContact = true;
      var field = appendDetailField(
        fields,
        fieldLabels[section.key],
        section.kind === 'list' ? section.items : section.text,
        fieldSelectors[section.key],
        section.kind
      );
      if (field && section.kind === 'contact' && section.href) {
        var paragraph = field.querySelector('p');
        if (paragraph) {
          var contactLink = document.createElement('a');
          contactLink.href = section.href;
          contactLink.textContent = section.text;
          paragraph.replaceChildren(contactLink);
        }
      }
    });
    if (!hasContact) {
      var contactHref = allowedAllEventsUrl(cfg.contactUrl);
      if (contactHref) {
        var contactField = appendDetailField(fields, t(cfg, 'contact'), t(cfg, 'contact'), 'data-fh-event-detail-contact', 'contact');
        var contactParagraph = contactField && contactField.querySelector('p');
        if (contactParagraph) {
          var fallbackContactLink = document.createElement('a');
          fallbackContactLink.href = contactHref;
          fallbackContactLink.textContent = t(cfg, 'contact');
          contactParagraph.replaceChildren(fallbackContactLink);
        }
      }
    }
    if (fields.childElementCount) detailBody.appendChild(fields);
    layout.appendChild(main);

    var bookingPanel = document.createElement('aside');
    bookingPanel.className = 'fh-events__booking-panel';
    bookingPanel.setAttribute('data-fh-event-booking-panel', '');
    bookingPanel.setAttribute('aria-label', t(cfg, 'booking_summary'));
    appendTextElement(bookingPanel, 'p', 'fh-events__price-line', getDiscoveryPrice(eventDto, viewModel, cfg), 'data-fh-event-price');
    appendTextElement(bookingPanel, 'p', 'fh-events__availability', getFriendlyAvailability(viewModel, cfg), 'data-fh-event-availability');
    if (safeText(eventDto && eventDto.booking_mode, 'none') === 'shopify_checkout') {
      appendTextElement(
        bookingPanel,
        'p',
        'fh-events__booking-support',
        viewModel.customerState === 'logged_out' ? t(cfg, 'login_required_copy') : t(cfg, 'paid_entry_supporting'),
        'data-fh-event-booking-support'
      );
    }
    if (viewModel.badgeText) {
      var badge = createBookingBadge(viewModel.badgeKind, viewModel.badgeText);
      if (badge) bookingPanel.appendChild(badge);
    }
    var cta = buildBookingAction(eventDto, cfg);
    if (cta) {
      var ctaWrap = document.createElement('div');
      ctaWrap.className = 'fh-events__cta-wrap';
      ctaWrap.appendChild(cta);
      bookingPanel.appendChild(ctaWrap);
    }
    layout.appendChild(bookingPanel);
    layout.appendChild(media);
    if (detailBody.childElementCount) layout.appendChild(detailBody);

    item.appendChild(layout);
    root.appendChild(item);
    trackAnalytics('event_detail_viewed', {
      event_slug: slug,
      surface: 'detail',
      booking_mode: safeText(eventDto.booking_mode, 'none'),
      customer_state: viewModel.customerState
    }, { once: true, dedupeKey: slug });
  }

  function renderEvents(root, events, cfg) {
    if (cfg.displayMode === 'catalogue' || cfg.surface === 'drawer') {
      renderDiscoveryEvents(root, events, cfg);
      return;
    }
    if (cfg.displayMode === 'detail') {
      renderDetailEvents(root, events, cfg);
      return;
    }

    root.innerHTML = '';

    var list = document.createElement('div');
    list.className = 'fh-events__list';
    if (cfg.layout === 'sidebar') list.classList.add('fh-events__list--sidebar');

    var sortedEvents = sortEventsChronological(events);

    sortedEvents.forEach(function (eventDto) {
      var item = document.createElement('article');
      item.className = 'fh-events__item';
      if (cfg.layout === 'sidebar') item.classList.add('fh-events__item--sidebar');
      var eventSlug = toSafeEventSlug(eventDto.slug);
      if (eventSlug) {
        item.id = 'event-' + eventSlug;
        item.setAttribute('data-fh-event-card', '');
        item.setAttribute('data-fh-event-slug', eventSlug);
      }

      var header = document.createElement('div');
      header.className = 'fh-events__header';

      if (cfg.showMonthBadge) {
        var badgeData = formatDateBadge(eventDto, cfg.locale, cfg.fallbackTz);
        if (badgeData) {
          var badge = document.createElement('div');
          badge.className = 'fh-events__date-badge';

          var badgeMonth = document.createElement('span');
          badgeMonth.className = 'fh-events__date-badge-month';
          badgeMonth.textContent = badgeData.monthShort;

          var badgeDay = document.createElement('span');
          badgeDay.className = 'fh-events__date-badge-day';
          badgeDay.textContent = badgeData.day;

          badge.appendChild(badgeMonth);
          badge.appendChild(badgeDay);
          header.appendChild(badge);
        }
      }

      var headerContent = document.createElement('div');
      headerContent.className = 'fh-events__header-content';

      var title = document.createElement('h3');
      title.className = 'fh-events__title';
      title.textContent = normalizeDisplayText(safeText(eventDto.title, 'Event'));
      headerContent.appendChild(title);

      var dateLine = cfg.showDateTime ? formatDateRange(eventDto, cfg.locale, cfg.fallbackTz) : '';
      if (dateLine) {
        var dateMeta = document.createElement('p');
        dateMeta.className = 'fh-events__meta';
        dateMeta.textContent = dateLine;
        headerContent.appendChild(dateMeta);
      }

      header.appendChild(headerContent);
      item.appendChild(header);

      var location = normalizeDisplayText(eventDto.location_text);
      if (location) {
        var locationMeta = document.createElement('p');
        locationMeta.className = 'fh-events__meta';
        locationMeta.textContent = location;
        item.appendChild(locationMeta);
      }

      if (cfg.showCategory) {
        var category = mapCategoryLabel(eventDto.category, cfg);
        if (category) {
          var categoryMeta = document.createElement('p');
          categoryMeta.className = 'fh-events__meta';
          categoryMeta.textContent = t(cfg, 'category_label') + ': ' + category;
          item.appendChild(categoryMeta);
        }
      }

      var viewModel = buildEventViewModel(eventDto, cfg);
      var customerModelApi = window.FunnyHooksEventsCustomerViewModel;
      if (customerModelApi && typeof customerModelApi.buildCustomerViewModel === 'function') {
        var booking = eventSlug ? getBookingState(eventSlug) : null;
        var countdownSeconds = booking
          ? secondsUntil(booking.expiresAt || (eventDto && eventDto.customer_booking_expires_at))
          : null;
        var customerPresentation = customerModelApi.buildCustomerViewModel({
          bookingMode: safeText(eventDto && eventDto.booking_mode, 'none'),
          runtimeState: viewModel.customerState,
          loggedIn: !!cfg.customerLoggedIn,
          pending: !!(booking && booking.pending),
          available: viewModel.availability ? viewModel.availability.available : null,
          total: viewModel.availability ? viewModel.availability.total : null,
          priceRequired: !!viewModel.priceRequired,
          priceDisplay: viewModel.priceDisplay || '',
          countdownSeconds: countdownSeconds
        });
        item.setAttribute('data-fh-customer-state', customerPresentation.state);
        item.setAttribute('data-fh-customer-action', customerPresentation.primaryAction.kind);
        item.setAttribute('data-fh-customer-message-key', customerPresentation.messageKey);
      }

      if (cfg.showAvailability) {
        if (viewModel.availability) {
          var avail = document.createElement('p');
          avail.className = 'fh-events__availability';
          avail.setAttribute('data-fh-events-availability', '');
          avail.textContent = t(cfg, 'availability_label') + ': ' + viewModel.availability.available + ' / ' + viewModel.availability.total;
          item.appendChild(avail);
        }
      }

      if (viewModel.priceDisplay) {
        var priceBlock = document.createElement('div');
        priceBlock.className = 'fh-events__price';
        priceBlock.setAttribute('data-fh-events-price', '');

        var priceLine = document.createElement('p');
        priceLine.className = 'fh-events__price-line';
        priceLine.textContent = t(cfg, 'paid_price_label') + ': ' + viewModel.priceDisplay;
        priceBlock.appendChild(priceLine);

        var priceNote = document.createElement('p');
        priceNote.className = 'fh-events__price-note';
        priceNote.textContent = t(cfg, 'paid_price_payment_note');
        priceBlock.appendChild(priceNote);

        item.appendChild(priceBlock);
      }

      if (viewModel.badgeText) {
        var badge = createBookingBadge(viewModel.badgeKind, viewModel.badgeText);
        if (badge) item.appendChild(badge);
      }

      if (cfg.showDescription) {
        var description = safeText(eventDto.description_html, '');
        if (description) {
          var desc = document.createElement('div');
          desc.className = 'fh-events__description';

          if (cfg.descriptionMode === 'html') {
            // Only safe when backend sanitizes description_html before sending it.
            desc.innerHTML = description;
          } else {
            desc.textContent = stripHtmlToText(description);
          }

          item.appendChild(desc);
        }
      }

      var modalSlug = viewModel.slug;
      var cta = createCta(eventDto, cfg, {
        onOpenBookingModal: function (opener) {
          openBookingModal(modalSlug, cfg, opener);
        }
      });
      if (cta) {
        var ctaWrap = document.createElement('div');
        ctaWrap.className = 'fh-events__cta-wrap';
        ctaWrap.appendChild(cta);
        item.appendChild(ctaWrap);
      }

      list.appendChild(item);
    });

    root.appendChild(list);

    var allEventsHref = allowedAllEventsUrl(cfg.allEventsUrl);
    if (allEventsHref) {
      var footer = document.createElement('div');
      footer.className = 'fh-events__footer';

      var allEventsLink = document.createElement('a');
      allEventsLink.className = 'fh-events__all-events-link';
      allEventsLink.href = allEventsHref;
      allEventsLink.textContent = t(cfg, 'all_events');

      if (new URL(allEventsHref).origin !== window.location.origin) {
        allEventsLink.target = '_blank';
        allEventsLink.rel = 'noopener noreferrer';
      }

      footer.appendChild(allEventsLink);
      root.appendChild(footer);
    }
  }

  function readConfig(root) {
    return {
      contractVersion: safeText(root.getAttribute('data-fh-events-contract'), ''),
      surface: safeText(root.getAttribute('data-fh-events-surface'), 'list'),
      endpoint: safeText(root.getAttribute('data-endpoint'), '/apps/fh-bobbel/events'),
      eventsRequestEndpoint: safeText(
        root.getAttribute('data-events-request-endpoint'),
        safeText(root.getAttribute('data-endpoint'), '/apps/fh-bobbel/events')
      ),
      responseMode: safeText(root.getAttribute('data-fh-events-response-mode'), 'list'),
      displayMode: safeText(root.getAttribute('data-fh-events-display-mode'), 'list'),
      limit: toInt(root.getAttribute('data-limit'), 6),
      layout: safeText(root.getAttribute('data-layout'), 'list'),
      showMonthBadge: toBool(root.getAttribute('data-show-month-badge')),
      showDateTime: toBool(root.getAttribute('data-show-date-time')),
      showCategory: toBool(root.getAttribute('data-show-category')),
      showAvailability: toBool(root.getAttribute('data-show-availability')),
      showDescription: toBool(root.getAttribute('data-show-description')),
      descriptionMode: safeText(root.getAttribute('data-description-mode'), 'plain'),
      locale: safeText(root.getAttribute('data-locale'), 'de-AT'),
      fallbackTz: safeText(root.getAttribute('data-time-zone-fallback'), 'Europe/Vienna'),
      allEventsUrl: safeText(root.getAttribute('data-all-events-url'), ''),
      contactUrl: safeText(root.getAttribute('data-contact-url'), ''),
      customerLoggedIn: toBool(root.getAttribute('data-customer-logged-in')),
      accountLoginUrl: safeText(root.getAttribute('data-account-login-url'), '/account/login'),
      accountRegisterUrl: safeText(root.getAttribute('data-account-register-url'), '/account/register'),
      runtimePageEnabled: toBool(root.getAttribute('data-runtime-page-enabled')),
      runtimeDrawerEnabled: toBool(root.getAttribute('data-runtime-drawer-enabled')),
      maintenanceMessage: safeText(root.getAttribute('data-maintenance-message'), t(null, 'maintenance')),
      i18n: readI18n(root)
    };
  }

  function warnIfUnsupportedRootContract(root, cfg) {
    if (!root || !cfg || cfg.contractVersion === 'v1' || root.__fhEventsContractWarned) return;
    root.__fhEventsContractWarned = true;
    if (!window.console || typeof window.console.warn !== 'function') return;
    window.console.warn('[fh-events] Expected data-fh-events-contract="v1" on root.', {
      contractVersion: cfg.contractVersion || '(missing)',
      surface: cfg.surface || '(unknown)'
    });
  }

  function shouldFailOpenForConfig(cfg) {
    return cfg.surface === 'page' || cfg.surface === 'list';
  }

  function applyPublicConfig(root, cfg, publicConfig) {
    var effectivePageEnabled = cfg.runtimePageEnabled && publicConfig.events_page_enabled !== false;
    var effectiveDrawerEnabled = cfg.runtimeDrawerEnabled && publicConfig.events_drawer_enabled !== false;

    if (cfg.surface === 'drawer') {
      if (!effectiveDrawerEnabled) {
        hideDrawerRail(root);
        return { allowRender: false, reason: 'drawer_disabled' };
      }
      revealDrawerRail(root);
      return { allowRender: true };
    }

    if ((cfg.surface === 'page' || cfg.surface === 'list') && !effectivePageEnabled) {
      renderMaintenanceState(root, publicConfig.events_page_maintenance_message || cfg.maintenanceMessage);
      return { allowRender: false, reason: 'page_disabled' };
    }

    return { allowRender: true };
  }

  function fetchAndRender(root) {
    var cfg = readConfig(root);
    warnIfUnsupportedRootContract(root, cfg);
    ensurePaidCartRemoveObserver(cfg);
    registerRoot(root, cfg);
    root.setAttribute('data-layout', cfg.layout);
    if (cfg.surface === 'drawer') {
      hideDrawerRail(root);
    } else {
      renderState(root, 'loading', t(cfg, 'loading'));
    }

    function loadEvents() {
      var url = cfg.responseMode === 'detail'
        ? cfg.eventsRequestEndpoint
        : buildUrl(cfg.eventsRequestEndpoint, cfg.limit);

      fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (res) {
          if (!res.ok) {
            var responseError = new Error('HTTP ' + res.status);
            responseError.fhStatus = res.status;
            throw responseError;
          }
          return res.json();
        })
        .then(function (payload) {
          var data = payload && payload.data ? payload.data : null;
          var events = cfg.responseMode === 'detail'
            ? (data && data.event ? [data.event] : null)
            : (data && Array.isArray(data.events) ? data.events : null);
          if (!payload || payload.contract_version !== 'v1' || !events) {
            throw new Error('Unexpected v1 envelope shape');
          }

          if (!events.length) {
            updateRootRegistration(root, cfg, events);
            renderState(root, 'empty', t(cfg, 'empty'));
            if (cfg.surface === 'drawer') revealDrawerRail(root);
            return;
          }

          upsertEvents(events);
          updateRootRegistration(root, cfg, events);

          if (cfg.customerLoggedIn) {
            events.forEach(function (eventDto) {
              if (!eventDto || safeText(eventDto.booking_mode, 'none') !== 'free') return;
              var slug = toSafeEventSlug(eventDto.slug);
              if (!slug) return;
              setBookingState(slug, {
                status: 'loading',
                hydrated: false,
                pending: false,
                errorMessage: '',
                infoMessage: ''
              });
            });
          }

          fetchCustomerBookingStatuses(events, cfg)
            .then(function (statusBySlug) {
              mergeBookingStatuses(events, cfg, statusBySlug, false);
            })
            .catch(function () {
              mergeBookingStatuses(events, cfg, {}, true);
            })
            .finally(function () {
              renderEvents(root, events, cfg);
              schedulePaidHoldCountdownTick();
              if (cfg.surface === 'drawer') revealDrawerRail(root);
              scrollToEventHashTarget();
              root.dispatchEvent(
                new CustomEvent('fh:events:loaded', {
                  detail: { count: events.length, endpoint: cfg.endpoint }
                })
              );
              resumeIntendedAction(root, events, cfg);
            });
        })
        .catch(function (error) {
          if (cfg.surface === 'drawer') {
            hideDrawerRail(root);
            return;
          }
          if (cfg.responseMode === 'detail' && error && error.fhStatus === 404) {
            renderState(root, 'not-found', t(cfg, 'empty'));
            return;
          }
          renderState(root, 'error', t(cfg, 'load_error'));
        });
    }

    fetchPublicConfig(cfg.endpoint)
      .then(function (publicConfig) {
        var decision = applyPublicConfig(root, cfg, publicConfig);
        if (decision && decision.allowRender === false) return;
        loadEvents();
      })
      .catch(function () {
        if (shouldFailOpenForConfig(cfg)) {
          loadEvents();
          return;
        }
        hideDrawerRail(root);
      });
  }

  function init() {
    bootstrapPaidCartRemoveObserver();

    var roots = document.querySelectorAll('[data-fh-events]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      if (root.__fhEventsInitialized) return;
      root.__fhEventsInitialized = true;
      if (!root.__fhEventsReloadInstalled) {
        root.__fhEventsReloadInstalled = true;
        root.addEventListener('fh:events:reload', function () {
          fetchAndRender(root);
        });
      }
      fetchAndRender(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var container = event && event.target;
    if (!container || !container.querySelectorAll) return;
    var roots = container.querySelectorAll('[data-fh-events]');
    roots.forEach(function (root) {
      root.__fhEventsInitialized = false;
    });
    init();
  });

  window.addEventListener('hashchange', scrollToEventHashTarget);

  window.addEventListener('focus', refreshAllEventRoots);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      refreshAllEventRoots();
    }
  });
})();
